<template>
  <div class="desk-page">
    <desk-state-modal
      v-if="modal.deskState.show"
      @close="closeModalDeskState('close')"
      @finish="closeModalDeskState('finish')"
      :statusFilters="statusFilters"
      :filter="filter"
      :columns="columnsMirror"
      context="DESK"
    />

    <MainHeader classModify="page-screen-import"/>

    <div class="slim-mainpanel">
      <div class="d-flex justify-content-between align-items-center pd-b-5 pd-t-5 menu-desk" >
        <ul class="nav nav-white-800 tx-white">
          <li
            class="nav-item tx-thin pd-0"
            v-if="filter !== null && filter.selectedTeams.length > 0"
          >
            <a
              href="#"
              class="nav-link pd-r-5 no-pointer"
              title="Equipes Operacionais"
            >
              <span class="pd-r-5 tx-medium">
                <i class="icon ion-person-stalker tx-medium"></i> Times Operacionais:
              </span>
              <span>
                {{ filter.selectedTeams.map(team => team.name).join(', ') }}
              </span>
              <i
                class="fa fa-close cursor-pointer"
                @click.prevent="filter.selectedTeams = []; newSearchProcesses()"
              ></i>
            </a>
          </li>
		  <li
            class="nav-item tx-thin pd-0"
            v-if="filter !== null && filter?.selectedCustomsTeams && filter.selectedCustomsTeams.length > 0"
          >
            <a
              href="#"
              class="nav-link pd-r-5 no-pointer"
              title="Times Aduaneiro"
            >
              <span class="pd-r-5 tx-medium">
                <i class="icon ion-person-stalker tx-medium"></i> Times Aduaneiro:
              </span>
              <span>
                {{ filter.selectedCustomsTeams.map(customsTeam => customsTeam.name).join(', ') }}
              </span>
              <i
                class="fa fa-close cursor-pointer"
                @click.prevent="filter.selectedCustomsTeams = []; newSearchProcesses()"
              ></i>
            </a>
          </li>
          <li
            class="nav-item tx-thin pd-0"
            v-if="
              filter.selectedDateRange.from &&
              filter.selectedDateRange.to &&
              filter.selectedDateField
            "
          >
            <a
              href="#"
              class="nav-link pd-r-5 no-pointer"
              title="Filtro de Datas"
            >
              <span class="pd-r-5 tx-medium">
                <i class="fa fa-calendar tx-medium"></i> Data da(o)
                {{ filter.selectedDateField.label }}:</span
              >
              <span>
                {{ filter.selectedDateRange.from | moment("DD/MM/YYYY") }} até
                {{ filter.selectedDateRange.to | moment("DD/MM/YYYY") }}
                <i
                  class="fa fa-close cursor-pointer"
                  @click.prevent="clearSearchFilterComplete('selectedDateRange'); newSearchProcesses()"
                ></i>
              </span>
            </a>
          </li>
        </ul>
        <ul
          class="nav nav-white-800 tx-white tx-15 align-items-center"
          role="tablist"
        >
          <li class="nav-item filter-button">
            <a
              href=""
              class="nav-link pd-r-5"
              title="Filtrar"
              @click.prevent="showFilterDrawer = true"
            >
              <i class="icon ion-funnel tx-bold"></i>
              <span class="tx-thin tx-15 mg-l-5">Filtrar</span>
			  <span 
                v-if="selectedFiltersCount > 0" 
                class="badge badge-danger"
                style="margin-left: 5px;"
              >
                {{ selectedFiltersCount }}
              </span>
            </a>
          </li>

          <li class="nav-item">
            <a
              href=""
              class="nav-link pd-r-5"
              title="Salvar"
              @click.prevent="handleSaveDeskState"
            >
              <i class="icon fa fa-save tx-bold"></i>
              <span class="tx-thin tx-15 mg-l-5 mg-l-5">Salvar</span>
            </a>
          </li>
          <li class="nav-item">
            <div class="dropdown dropdown-a dropleft">
              <a
                href=""
                class="nav-link pd-r-5"
                :title="profileButtonTitle"
                data-toggle="dropdown"
              >
                <i class="icon ion-person-stalker"></i>
                <span class="tx-thin tx-15 mg-l-5 mg-l-5">{{ profileButtonLabel }}</span>
                <i
                  v-if="activeDeskState"
                  class="fa fa-close cursor-pointer mg-l-5"
                  title="Limpar perfil"
                  @click.stop.prevent="clearActiveDeskState"
                ></i>
              </a>

              <div
                class="dropdown-menu dropdown-media-list wd-450"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div class="dropdown-menu-header">
                  <label
                  >Perfis Cadastrados ({{ this.deskStates.length }})</label
                  >
                  <div>
                    <a
                      v-if="activeDeskState"
                      href="#"
                      class="tx-12"
                      @click.prevent="clearActiveDeskState"
                    >LIMPAR PERFIL</a>
                    <a
                      href="#"
                      class="tx-12"
                      @click.prevent="handleSaveDeskState"
                    >+ SALVAR ESTADO DA MESA</a>
                  </div>
                </div>

                <div
                  class="list-group list-group-striped list-group-user bd-t-0--force"
                >
                  <template v-if="this.deskStates.length > 0">
                    <div
                      class="list-group-item"
                      :class="{ 'profile-item-active': isActiveDeskState(state) }"
                      :key="'listOfStates-state-' + index"
                      v-for="(state, index) in this.deskStates"
                    >
                      <div
                        class="user-name-address mg-0"
                        @click="selectDeskStates(state)"
                      >
                        <p>{{ state.name }}</p>
                        <span>{{ state.created | moment("DD/MM/YYYY") }}</span>
                      </div>
                      <div class="user-btn-wrapper">
                        <!-- <a href="#" class="btn btn-outline-primary btn-icon">
                            <div class="tx-18"><i class="icon ion-edit"></i></div>
                        </a> -->
                        <a
                          href="#"
                          class="btn btn-outline-danger btn-icon"
                          @click.prevent="deleteDeskStates(state)"
                        >
                          <div class="tx-18">
                            <i class="icon ion-trash-a"></i>
                          </div>
                        </a>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="media-body">
                      <p class="pd-10 tx-center">
                        Nenhum perfil foi cadastrado.
                      </p>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </li>

          <!-- <li class="nav-item">
              <a href="" class="nav-link" title="Imprimir" @click.prevent>
                  <i class="icon fa fa-print tx-bold"></i>
                  <span class="tx-thin tx-14 mg-l-5"> Imprimir </span>
              </a>
          </li> -->
          <li class="nav-item">
            <a
              href=""
              class="nav-link pd-r-5"
              title="Configuração de Colunas"
              @click.prevent="showColumnsDrawer = true"
            >
              <i class="icon ion-settings"></i>
              <span class="tx-thin tx-14 mg-l-5">Configuração de Colunas</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              href=""
              class="nav-link pd-r-5"
              title="Legenda"
              @click.prevent="showLegendDrawer = true"
            >
              <i class="icon ion-bookmark tx-bold"></i>
              <span class="tx-thin tx-15 mg-l-5">Legendas</span>
            </a>
          </li>
          <li class="nav-item">
            <div class="dropdown dropdown-a dropleft desk-header-actions">
              <a
                href=""
                class="nav-link pd-r-5 desk-header-actions__toggle"
                title="Ações"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="icon fa fa-magic tx-white tx-16"></i>
                <span class="tx-thin tx-15 mg-l-5">Ações</span>
                <i class="fa fa-angle-down tx-11 mg-l-3 op-5"></i>
              </a>
              <div
                class="dropdown-menu dropdown-menu-right desk-header-actions__menu pd-0"
              >
                <div class="dropdown-menu-header">
                  <label class="mg-b-0">Ferramentas da mesa</label>
                </div>
                <ul class="list-group bd-t-1 mg-b-0">
                  <li
                    class="list-group-item desk-header-actions__item pd-y-12"
                    @click.prevent="openConsultaCesIncluidosModal"
                  >
                    <div class="media align-items-center mg-b-0">
                      <div
                        class="wd-40 ht-40 rounded-5 bg-gray-100 d-flex align-items-center justify-content-center mg-r-12"
                      >
                        <i class="fa fa-cubes tx-primary tx-18"></i>
                      </div>
                      <div class="media-body">
                        <span class="tx-14 tx-medium tx-inverse d-block"
                          >Consulta CEs Incluídos</span
                        >
                        <small class="tx-12 text-muted"
                          >Pesquisar CEs já vinculados aos processos</small
                        >
                      </div>
                      <i class="fa fa-angle-right tx-gray-500 tx-14 mg-l-8"></i>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <a
              href=""
              class="nav-link pd-r-0"
              title="Adicionar"
              @click.prevent="newProcess"
            >
              <i class="icon fa fa-plus-square tx-bold"></i>
              <span class="tx-thin tx-15 mg-l-5">Adicionar</span>
            </a>
          </li>

          <li
            class="tx-20 nav-item search-item nav-link"
          >
            <i class="icon ion-bookmark"></i>
            <form
              @submit.prevent="findProcessByIdentificationSearch()"
              @keyup.escape="findProcessByIdentificationClearSearch()"
            >
              <label for="">
                <input
                  type="number"
                  v-model="findProcessByIdentification"
                  id="findProcessByIdentification"
                  placeholder="Nº Ref"
                  class="wd-75 tx-thin tx-20 tx-center imput-process-by-identification"
                />
                <span
                  v-if="findProcessByIdentification != ''"
                  @click="findProcessByIdentificationClearSearch()"
                >
                  <i class="fa fa-times-circle" aria-hidden="true"></i>
                </span>
              </label>
            </form>
          </li>
        </ul>
      </div>

      <div class="row mg-0 align-items-center">
        
        <div class="col-sm-12 flex justify-content-between align-items-center pd-t-5 pd-b-5">
            <div class="tx-black flex ai-c" style="flex: 0 0 15%">
              <label class="mb-0">Total de <strong>{{ processes.length }}</strong> processos</label>
            </div>
            <div class="flex1 flex ai-c jc-c" style="flex: 0 0 70%">
              <ul class="nav nav-pills status-filters nav-gray-600" role="tablist">
                <li
                  class="nav-item tx-thin"
                  v-for="step in this.steps"
                  :key="step.code"
                >
                  <label class="cursor-pointer mb-0">
                    <div
                      v-if="
                        step !== undefined &&
                        step !== null &&
                        step.code &&
                        step.code != 'todas' && 
                        step.id != 11
                      "
                    >
                      <input
                        v-if="step.id !== 6"
                        type="checkbox"
                        name="filter-status"
                        v-model="statusFilters"
                        :value="step.id"
                      />
                      <template v-if="step.id === 6">
                        <div
                          class="nav-link pointer"
                          @click.prevent.stop="showCompletedProcessesDrawer = true"
                        >
                          <span>{{ step.alias }}</span>
                        </div>
                      </template>
                      <template
                        v-else-if="statusFilters !== null && statusFilters.includes(step.id)"
                      >
                        <div
                          class="nav-link"
                          :class="[{ active: checkActiveStep(step.id) }]"
                          :style="[
                            {
                              borderColor: step.color,
                              backgroundColor: step.color,
                              color: step.textColor,
                            },
                          ]"
                        >
                          <span>{{
                            step.code == "todas" ? "Todas" : step.alias
                          }}</span>
                        </div>
                      </template>
                      <template v-else>
                        <div class="nav-link">
                          <span>{{
                            step.code == "todas" ? "Todas" : step.alias
                          }}</span>
                        </div>
                      </template>
                    </div>
                    <!-- <div v-if="step.code == 'todas'">
                    <div class="nav-link" @click="statusFilters = []">
                        <span>Todas</span>
                    </div>
                </div> -->
                  </label>
                </li>
              </ul>
            </div>
            <div class="flex ai-c" style="flex: 0 0 15%;">
              <form
                @submit.prevent="searchProcesses('searchFilter')"
                @keyup.escape="clearSearch()"
                class="wd-100p z-index-10"
              >
                <div class="input-group wd-100p z-index-10">
                    <button class="btn bd bg-white tx-gray-600 bd-r-0 tx-thin" type="button" @click.prevent="searchProcesses('searchFilter')">
                      <i class="fa fa-search tx-primary"></i>
                    </button>
                  <input
                    type="text" v-model="searchTerms" id="searchProcesses" placeholder="Pesquisar abaixo..." class="wd-100p form-control"/>
                  <span class="input-group-btn">
                    <button class="btn bd bg-white tx-gray-600 bd-l-0 tx-thin" type="button" v-if="searchTerms != ''" @click="clearSearch()" >
                      <i class="icon ion-trash-a tx-14 "></i>
                    </button>

                  </span>
                </div>
              </form>
            </div>
        </div>

        <div
          class="col-md-12 table-area z-index-100"
          v-show="!showProcess"
          :class="{ showHeader: showHeader, showSearch: showSearch }"
        >
          <processes-table
            :columns="columns"
            :flash-process-id="deskTableFlashProcessId"
            @new-process="newProcess()"
          />
        </div>
      </div>
    </div>

    <Drawer v-if="showFilterDrawer" @close="showFilterDrawer = false" :showScroll="true" classModalDialog="widthModify">
      <template slot="header">
        <div>Filtros do Telão Operacional</div>
      </template>
      <template slot="body">
        <div class="mg-y-20 mg-x-10">
			<div class="form-layout form-layout-2">
				<h6 class="slim-pagetitle">Filtros de Datas</h6>
				<br/>
				<div class="row no-gutters">
					<div class="col-md-6">
						<div class="form-group filter-date">
							<label class="form-control-label"> Data Inicial <span class="tx-danger">*</span></label>
							<date-picker lang="pt-br"
										v-model="filter.selectedDateRange.from"
										name="toPickedDate"
										format="DD/MM/YYYY"
										placeholder="Data Inicial"
							></date-picker>
						</div>
					</div>
					<div class="col-md-6 mg-t--1 mg-md-t-0">
						<div class="form-group mg-md-l--1 filter-date">
							<label class="form-control-label"> Data Final <span class="tx-danger">*</span></label>
							<date-picker lang="pt-br"
									v-model="filter.selectedDateRange.to"
									name="toPickedDate"
									format="DD/MM/YYYY"
									placeholder="Data Final"
							></date-picker>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label"> Campo do Filtro </label>
							<v-select
								v-model="filter.selectedDateField"
								:options="listOfDatesFields"
								name="label"
							>
								<template slot="option" slot-scope="option">
									{{ option.label }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
            	<h6 class="slim-pagetitle mg-t-20">Filtros Gerais</h6>
				<br/>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group">
							<label class="form-control-label"> Times Operacionais </label>
							<v-select
								v-model="filter.selectedTeams"
								label="name"
								:options="teams"
								name="team"
								multiple
							>
								<template slot="option" slot-scope="option">
									{{ option.name + " - " + option.email }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12 ">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label"> Times Aduaneiro </label>
							<v-select
								v-model="filter.selectedCustomsTeams"
								label="name"
								:options="customsTeams"
								name="customsTeam"
								multiple
							>
								<template slot="option" slot-scope="option">
									{{ option.name}}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Licença de Importação
							</label>
							<v-select
								v-model="filter.selectedImportLicenses"
								label="name"
								:options="listOfImportLicenses"
								name="selectedImportLicenses"
							>
								<template slot="option" slot-scope="option">
									{{ option.name }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Despachante Aduaneiro
							</label>
							<v-select
								v-model="filter.selectedCustomsBrokers"
								label="name"
								:options="customsBrokers"
								name="customsBroker"
								multiple
							>
								<template slot="option" slot-scope="option">
									{{ option.name }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Via de Transporte
							</label>
							<v-select
								v-model="filter.selectedWaysOfTransport"
								label="name"
								:options="listOfWayOfTransport"
								name="wayOfTransport"
								multiple
							>
								<template slot="option" slot-scope="option">
								{{ option.name }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Incoterm
							</label>
							<v-select
								v-model="filter.selectedIncoterms"
								label="name"
								:options="listOfIncoterms"
								name="incoterm"
								multiple
								class="top-down-filter"
							>
								<template slot="option" slot-scope="option">
								{{ option.name }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Recinto Alfandegado
							</label>
							<v-select
								v-model="filter.selectedCustomsEnclosuresIds"
								label="name"
								:options="listCustomsEnclosures"
								name="customsEnclosures"
								multiple
								class="top-down-filter"
							>
								<template slot="option" slot-scope="option">
								{{ option.name }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Canal da DI
							</label>
							<v-select
								v-model="filter.selectedDiChannels"
								label="name"
								:options="listOfDiChannels"
								name="diChannel"
								multiple
								class="top-down-filter"
							>
								<template slot="option" slot-scope="option">
								{{ option.name }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Tipo de Processo
							</label>
							<v-select
								v-model="filter.selectedTypesOfProcess"
								label="name"
								:options="listOfTypeOfProcess"
								name="typeOfProcess"
								multiple
								class="top-down-filter"
							>
								<template slot="option" slot-scope="option">
								{{ option.name }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Urgente
							</label>
							<v-select
								v-model="filter.selectedUrgent"
								label="name"
								:options="listOfUrgent"
								name="selectedUrgent"
								class="top-down-filter"
							>
								<template slot="option" slot-scope="option">
									{{ option.name }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Prioridade
							</label>
							<v-select
								v-model="filter.selectedPriority"
								label="name"
								:options="listOfPriority"
								name="selectedPriority"
								class="top-down-filter"
							>
								<template slot="option" slot-scope="option">
									{{ option.name }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Tipos de Prioridade
							</label>
							<v-select
								v-model="filter.selectedPriorityTypes"
								label="name"
								:options="listPriorityTypes"
								name="selectedPriorityTypes"
								class="top-down-filter"
								multiple
							>
								<template slot="option" slot-scope="option">
								{{ option.name }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div class="row no-gutters">
					<div class="col-md-12">
						<div class="form-group bd-t-0-force">
							<label class="form-control-label">
								Modalidade do Radar
							</label>
							<v-select
								v-model="filter.selectedRadarModality"
								label="label"
								:options="salesRadarModalities"
								name="selectedRadarModality"
								class="top-down-filter"
							>
								<template slot="option" slot-scope="option">
									{{ option.label }}
								</template>
							</v-select>
						</div>
					</div>
				</div>
          	</div>
        </div>
      </template>
      <template slot="footer">
		<a
			href="#"
			class="btn btn-primary btn-block mg-t-10"
			@click.prevent="newSearchProcesses"
		>
			<i class="icon ion-funnel tx-bold"></i> FILTRAR
		</a>
		<a
			href="#"
			class="btn btn-danger btn-block mg-t-10"
			@click.prevent="
			clearSearchFilterComplete('filterSelect');
			"
		>
			<i class="icon ion-funnel tx-bold"></i> LIMPAR
		</a>
        <a
          href="#"
          @click="showFilterDrawer = false"
          class="btn btn-secondary mg-t-8"
        >
          Fechar
        </a>
      </template>
    </Drawer>
    <Drawer v-if="showLegendDrawer" @close="showLegendDrawer = false">
      <template slot="header">
        <div>Legenda dos Campos</div>
      </template>
      <template slot="body">
        <div class="mg-y-20 mg-x-10">
          <h6 class="slim-pagetitle">Legendas Disponíveis</h6>
          <br/>
          <div class="table-responsive">
            <table class="table table-striped mg-b-0">
              <thead>
              <tr>
                <th>Campo</th>
                <th>Regra</th>
                <th>Cor</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th scope="row">Seguro</th>
                <td>
                  ETA entre 0 <small>(hoje)</small> e 7 dias adiante se o
                  seguro não estiver preenchido.
                </td>
                <th class="bg-red"></th>
              </tr>
              <tr>
                <th scope="row">Seguro</th>
                <td>ETA que já passou do dia de hoje</td>
                <th class="bg-black"></th>
              </tr>
              <tr>
                <th scope="row">Numerário</th>
                <td>
                  ETD menor ou igual o número de dias preenchido no <br/>
                  cadastro do cliente
                  <small>(QUANTIDADE DIAS P/ NOTIFICAÇÃO DO NUMERÁRIO)</small
                  >.
                </td>
                <th class="bg-green"></th>
              </tr>
              <tr>
                <th scope="row">Encerramento Despachante</th>
                <td>Carregamento realizado há 3 dias ou mais.</td>
                <th class="bg-orange"></th>
              </tr>
              <tr>
                <th scope="row">ETA</th>
                <td>
                  ETA maior do que 7 e menor ou igual a 14 dias adiante.
                </td>
                <th class="bg-yellow"></th>
              </tr>
              <tr>
                <th scope="row">ETA</th>
                <td>
                  ETA maior do que 0 <small>(hoje)</small> e menor ou igual a
                  7 dias adiante.
                </td>
                <th class="bg-red"></th>
              </tr>
              <tr>
                <th scope="row">ETA</th>
                <td>ETA igual a 0 dias <small>(hoje)</small>.</td>
                <th class="bg-purple"></th>
              </tr>
              <tr>
                <th scope="row">DI</th>
                <td>Chegada a mais do que 2 dias.</td>
                <th class="bg-orange"></th>
              </tr>
              <tr>
                <th scope="row">Carregamento</th>
                <td>Desembaraço a mais do que 2 dias.</td>
                <th class="bg-orange"></th>
              </tr>
              <tr>
                <th scope="row">Documentos</th>
                <td>ETA menor ou igual a 14 dias adiante.</td>
                <th class="bg-orange"></th>
              </tr>
              <tr>
                <th scope="row">Entrega</th>
                <td>Carregamento menor que 1 dia adiante.</td>
                <th class="bg-orange"></th>
              </tr>
              <tr>
                <th scope="row">DTC / DTA</th>
                <td>
                  Se tiver DTC/DTA e Data de DTC/DTA não estiver preenchida.
                </td>
                <th class="bg-orange"></th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          type="button"
          @click="showLegendDrawer = false"
          class="btn btn-primary"
        >
          Fechar
        </button>
      </template>
    </Drawer>

    <Drawer v-if="showColumnsDrawer" @close="showColumnsDrawer = false">
      <template slot="header">
        <div>Configuração de Colunas do Telão Operacional</div>
      </template>
      <template slot="body">
        <div class="mg-y-20 mg-x-10 h-100">
          <two-select
            :originalItems="columnsModel"
            :originalSelectedItems="columnsMirror"
            @onChangeSelected="onChangeColumns"
          />
        </div>
      </template>
      <template slot="footer">
        <button
          type="button"
          @click="showColumnsDrawer = false"
          class="btn btn-primary"
        >
          Fechar
        </button>
      </template>
    </Drawer>

    <Drawer
      v-if="showCompletedProcessesDrawer"
      @close="closeCompletedProcessesDrawer"
    >
      <template slot="header">
        <div>Filtrar processos concluídos</div>
      </template>
      <template slot="body">
        <div class="mg-y-20 mg-x-10">
          <h6 class="slim-pagetitle mt-4 mb-2">Filtrar</h6>
          <span
          >Selecione um campo de dada e um período para filtrar os processos
            concluídos</span
          >
          <br/>
          <div class="form-layout form-layout-2 mt-4">
            <div class="row no-gutters">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="form-control-label">
                    Selecione um ou mais clientes
                  </label>
                  <v-select
                    v-model="formFilterConcludedProcesses.customersIds"
                    multiple
                    :options="customersActivesOptions"
                    name="label"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.label }}
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="row no-gutters">
              <div class="col-md-12">
                <div class="form-group bd-t-0-force">
                  <label class="form-control-label">
                    Selecione um campo de data <span class="tx-danger">*</span>
                  </label>
                  <v-select
                    v-model="formFilterConcludedProcesses.dateField"
                    :options="listOfDatesFields"
                    name="label"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.label }}
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="row no-gutters">
              <div class="col-md-6">
                <div class="form-group bd-t-0-force">
                  <label class="form-control-label">
                    Data Inicial <span class="tx-danger">*</span></label
                  >
                  <date-picker lang="pt-br"
                               v-model="formFilterConcludedProcesses.startDate"
                               name="toPickedDate"
                               format="DD/MM/YYYY"
                               placeholder="Data Inicial"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-6 mg-t--1 mg-md-t-0">
                <div class="form-group mg-md-l--1 bd-t-0-force">
                  <label class="form-control-label">
                    Data Final <span class="tx-danger">*</span></label
                  >
                  <date-picker lang="pt-br"
                               v-model="formFilterConcludedProcesses.endDate"
                               name="toPickedDate"
                               format="DD/MM/YYYY"
                               placeholder="Data Final"
                  ></date-picker>
                </div>
              </div>
            </div>
			<div class="row mt-4">
				<div class="col-md-12">
					<div class="alert alert-warning">
						<strong>Atenção:</strong> Este filtro considera apenas processos concluídos e ignora as outras etapas selecionadas.
					</div>
				</div>
			</div>
            <button
              class="btn btn-primary btn-block mg-t-10"
              @click.prevent="submitFilterConcludedProcesses"
            >
              <i class="icon ion-funnel tx-bold"></i> FILTRAR
            </button>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          type="button"
          @click="closeCompletedProcessesDrawer"
          class="btn btn-primary"
        >
          Fechar
        </button>
      </template>
    </Drawer>

    <ProcessForm
      v-if="showProcess"
      :class="{
        showHeader: showHeader,
        'process-form--fullscreen-over-modal': modalConsultaCesIncluidos.open,
      }"
      v-on:fecharProcesso="reloadProcesses"
    />
    <FabMenu/>
	<VModal :handler="newProcessModal" title="Novo Processo" description="" :width="800" :height="20" @requestClose="closeNewProcessModal" classModify="remove-overflow">
		<template #content>
			<div class="row no-gutters">
				<div class="col-md-12 mb-2">
					<div class="text-right">Os campos marcados com <span class="tx-danger">*</span> são obrigatórios.</div>
				</div>
				<div class="col-md-12 flex gap1">
					<div class="form-group wd-40p">
						<label class="form-control-label">Ref. Pedido/ Cliente</label>
						<input type="text" class="form-control input-modify__input" v-model="newProcessPayload.customerRef"/>
					</div>
					<div class="form-group wd-500 flex fd-c">
						<label class="form-control-label">Cliente <span class="tx-danger">*</span></label>				
						<multi-select 
							telao 
							:config="{
								options: customersActivesOptions,
								closeOnSelect: true,
								label: 'label',
								trackBy: 'attribute',
								placeholder: 'Selecione um cliente',
							}"
							:class="{'input-modify': true, 'danger': getError('customerId') }"
							v-model="newProcessPayload.customer"
						>
							<template #noResult>
								Nenhum cliente encontrado. Deseja
								<a href="#" @click.prevent="modalContactOpen = true">criar um novo cliente</a>?
							</template>
						</multi-select>
						<div class="field-error" v-if="getError('customerId')">
							{{ getError("customerId") }}
						</div>
					</div>
				</div>
				<div class="col-md-12">
					<span><strong class="tx-danger">Atenção:</strong> o despachante não será notificado automaticamente. Caso necessário, notifique-o manualmente.</span>
				</div>
			</div>
		</template>
		<template #footer>
			<div class="flex ai-c jc-c fgap2">
				<button class="crm-button red" @click.prevent="closeNewProcessModal">
					Cancelar
				</button>
				<button class="crm-button" @click.prevent="saveNewProcess">
					Criar
				</button>
			</div>
		</template>
	</VModal>
	<VModal
		:handler="modalConsultaCesIncluidos.open"
		title="Consulta CEs incluídos"
		description="Consulta CE Mercantes disponíveis e cruza com os processos para atualizar BL e CE-Mercante quando fizer sentido."
		title-id="consulta-ces-modal-title"
		description-id="consulta-ces-modal-desc"
		:width="consultaCesModalWidth"
		:height="consultaCesModalHeight"
		:close-on-escape="false"
		@requestClose="closeConsultaCesIncluidosModal"
		:class-modify="consultaCesModalClassModify"
	>
		<template #content>
			<div v-if="modalConsultaCesIncluidos.step === 1" class="consulta-ces-modal-step1">
				<div class="alert alert-light bd tx-12 mg-b-20 pd-y-10 pd-x-12 rounded">
					Escolha a <strong>unidade da empresa</strong> e a data da consulta (data de emissão do CE).
				</div>
				<div
					v-if="consultaCesErroConsulta"
					class="alert alert-danger tx-13 mg-b-20 pd-y-12 pd-x-15 rounded"
				>
					<p class="mg-b-10">{{ consultaCesErroConsulta }}</p>
					<button
						type="button"
						class="btn btn-sm btn-outline-danger"
						@click.prevent="tentarNovamenteConsultaCesIncluidos"
					>
						Tentar novamente
					</button>
				</div>
				<div class="consulta-ces-modal-grid">
					<div class="consulta-ces-field">
						<div
							class="consulta-ces-input-control input-control active"
							:class="{ 'consulta-ces-field--disabled': consultaCesAccountsLoading }"
						>
							<label class="no-events" for="consultaCesUnidadeSelect">
								Unidade / CNPJ do importador (consignatário)
								<span class="tx-danger">*</span>
							</label>
							<div class="select-wrapper-int">
								<v-select
									v-model="consultaCesSelectedAccount"
									:options="consultaCesUnidadeSelectOptions"
									:disabled="consultaCesAccountsLoading"
									:clearable="false"
									label="name"
									input-id="consultaCesUnidadeSelect"
									:placeholder="consultaCesAccountsLoading ? 'Carregando unidades…' : ''"
								>
								<template slot="option" slot-scope="option">
									<template v-if="option.id === consultaCesAllAccountId">
										<span class="tx-medium">{{ option.name }}</span>
										<small class="d-block tx-gray-600 tx-11">Consultar todas as unidades na mesma tela</small>
									</template>
									<template v-else>
										<span>{{ option.name }}</span>
										<small class="tx-gray-600 mg-l-5">({{ option.federalID || "—" }})</small>
									</template>
								</template>
								<template slot="selected-option-container" slot-scope="{ option }">
									<span class="selected-tag consulta-ces-vselect__selected">
										<template v-if="option.id === consultaCesAllAccountId">
											{{ option.name }}
											<small class="tx-gray-600 mg-l-5">(todas)</small>
										</template>
										<template v-else>
											{{ option.name }}
											<small class="tx-gray-600 mg-l-5">({{ option.federalID || "—" }})</small>
										</template>
									</span>
								</template>
								</v-select>
							</div>
						</div>
						<p
							v-if="!consultaCesAccountsLoading && consultaCesAccountsActive.length === 0"
							class="consulta-ces-field__error mg-t-8 mg-b-0"
						>
							Nenhuma unidade habilitada. Cadastre ou habilite em Configurações → Unidades da Empresa.
						</p>
					</div>
					<div class="consulta-ces-field">
						<v-input
							type="date"
							name="consultaCesDataConsulta"
							label="Data da consulta"
							v-model="consultaCesForm.dataConsultaDate"
							
						/>
					</div>
				</div>
			</div>
			<div v-else class="consulta-ces-result-wrap">
				<div
					v-if="!consultaCesLinhas || !consultaCesLinhas.length"
					class="consulta-ces-empty tx-center pd-y-25 pd-x-15"
				>
					<i class="fa fa-inbox tx-gray-400 tx-32 d-block mg-b-10"></i>
					<p class="tx-14 tx-medium tx-inverse mg-b-5">Nenhuma linha para esta consulta</p>
					<p class="tx-12 text-muted mg-b-0">
						Tente outra data ou confira se o CNPJ da unidade confere com o consignatário no Goods. Se a
						comunicação demorou ou expirou, use <strong>Nova consulta</strong> e tente de novo.
					</p>
				</div>
				<template v-else>
					<div class="consulta-ces-result-panel mg-b-12">
						<div class="consulta-ces-result-panel__toolbar">
							<div class="consulta-ces-result-panel__identity">
								<h3 class="consulta-ces-result-panel__title">Resultado da consulta</h3>
								<div class="consulta-ces-result-panel__meta-line">
									<template v-if="consultaCesResultadoUnidadeMeta">
										<span class="consulta-ces-result-panel__meta-item">
											<strong v-if="consultaCesIsAllUnidadesSelected">Unidades</strong>
											<strong v-else>CNPJ</strong>
											{{ consultaCesResultadoUnidadeMeta }}
										</span>
									</template>
									<template v-if="consultaCesResultadoDataExibicao">
										<span
											v-if="consultaCesResultadoUnidadeMeta"
											class="consulta-ces-result-panel__dot"
											aria-hidden="true"
										>·</span>
										<span class="consulta-ces-result-panel__meta-item">
											<strong>Data</strong>
											{{ consultaCesResultadoDataExibicao }}
										</span>
									</template>
								</div>
								<div class="consulta-ces-result-panel__counts-line">
									<span class="consulta-ces-result-panel__count-pill">
										<strong>{{ consultaCesResultadoResumoNumeros.nCes }}</strong>
										{{ consultaCesResultadoResumoNumeros.nCes === 1 ? " CE" : " CEs" }}
									</span>
									<span class="consulta-ces-result-panel__dot" aria-hidden="true">·</span>
									<span class="consulta-ces-result-panel__count-pill">
										<strong>{{ consultaCesResultadoResumoNumeros.nProc }}</strong>
										{{
											consultaCesResultadoResumoNumeros.nProc === 1
												? " processo na mesa"
												: " processos na mesa"
										}}
									</span>
								</div>
							</div>
							<div
								v-if="consultaCesLinhas && consultaCesLinhas.length"
								class="consulta-ces-result-panel__search"
							>
								<div class="consulta-ces-result-panel__search-field">
									<label class="consulta-ces-result-panel__search-label" for="consultaCesFilterInput">
										<i class="fa fa-search" aria-hidden="true"></i>
										<span>Filtrar</span>
									</label>
									<input
										id="consultaCesFilterInput"
										v-model="consultaCesFilterText"
										type="search"
										class="consulta-ces-result-panel__search-input"
										placeholder="CE, BL, processo, cliente…"
										autocomplete="off"
									/>
								</div>
								<span
									v-if="(consultaCesFilterText || '').trim()"
									class="consulta-ces-result-panel__filter-badge tx-11"
								>
									{{ consultaCesLinhasFiltradas.length }}/{{ consultaCesLinhas.length }} linhas
								</span>
							</div>
						</div>
						<p class="consulta-ces-result-panel__hint tx-11 text-muted mg-b-0">
							<strong>Conferência:</strong>
							todas as linhas da consulta aparecem. Só entram processos com BL compatível
							(<code class="tx-11">billOfLading</code> /
							<code class="tx-11">billOfLadingMaster</code>, trim e caixa baixa)
							e <strong>sem</strong> CE Mercante com dígitos. Quem já tem CE no processo não aparece.
							Célula vazia: BL sem processo pendente ou sem esse BL no Gescomex.
						</p>
					</div>
				<div
					v-if="!consultaCesLinhasFiltradas.length"
					class="consulta-ces-empty consulta-ces-empty--filter tx-center pd-y-20 pd-x-15"
				>
					<i class="fa fa-search tx-gray-400 tx-28 d-block mg-b-8"></i>
					<p class="tx-14 tx-medium mg-b-5">Nenhuma linha corresponde ao filtro</p>
					<p class="tx-12 text-muted mg-b-0">Limpe ou ajuste o campo Filtrar acima.</p>
				</div>
				<div
					v-else
					class="table-responsive consulta-ces-table-responsive consulta-ces-table-scroll"
				>
					<table class="table table-hover table-bordered table-striped tx-12 mg-b-0 consulta-ces-table">
						<thead class="consulta-ces-table__thead">
							<tr>
								<th>CE</th>
								<th>BL</th>
								<th>Tipo</th>
								<th>Manifesto</th>
								<th>Data</th>
								<th>Embarcação</th>
								<th>P. carga</th>
								<th>P. descarga</th>
								<th class="consulta-ces-th-processos">Processo(s)</th>
								<th class="consulta-ces-th-cliente">Cliente</th>
								<th class="consulta-ces-th-despachante">Despachante</th>
								<th class="consulta-ces-th-filial">Filial / unidade</th>
								<th class="consulta-ces-th-acao tx-center wd-60-force">Ação</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(linha, idx) in consultaCesLinhasFiltradas"
								:key="'ces-linha-' + idx + '-' + (linha.nrCeMercante || '') + '-' + (linha.numeroBl || '')"
							>
								<td class="ws-nw tx-medium">{{ linha.nrCeMercante || "—" }}</td>
								<td class="ws-nw">{{ linha.numeroBl || "—" }}</td>
								<td>{{ linha.tipo || "—" }}</td>
								<td class="ws-nw">{{ linha.numeroManifesto || "—" }}</td>
								<td class="ws-nw">{{ linha.dataOperacao || "—" }}</td>
								<td>{{ linha.embarcacao || "—" }}</td>
								<td class="ws-nw">{{ linha.portoCarregamento || "—" }}</td>
								<td class="ws-nw">{{ linha.portoDescarregamento || "—" }}</td>
								<td class="consulta-ces-td-processos va-m">
									<template v-if="linha.processosCompativeis && linha.processosCompativeis.length">
										<button
											v-if="consultaCesLinhaBulkCount(linha) > 1"
											type="button"
											class="btn btn-sm btn-outline-secondary mg-b-8"
											@click="confirmarBulkAtualizarCeMercante(linha)"
										>
											Sincronizar {{ consultaCesLinhaBulkCount(linha) }} processos desta linha
										</button>
										<div
											v-for="p in linha.processosCompativeis"
											:key="'p-ref-' + linha.nrCeMercante + '-' + p.id"
											class="consulta-ces-process-ref-row flex ai-c gap1 mg-b-4"
										>
											<span
												class="consulta-ces-process-ref consulta-ces-process-ref--link"
												role="button"
												tabindex="0"
												:title="
													'Abrir processo ' +
														(p.formattedReference || p.identification || p.id)
												"
												:aria-label="
													'Abrir processo ' +
														(p.formattedReference || p.identification || p.id)
												"
												@click.prevent="abrirProcessoDesdeConsultaCes(p)"
												@keydown.enter.prevent="abrirProcessoDesdeConsultaCes(p)"
												@keydown.space.prevent="abrirProcessoDesdeConsultaCes(p)"
											>
												{{ p.formattedReference || p.identification }}
											</span>
											<span
												v-if="consultaCesProcessoCeDivergeDoLinha(p, linha.nrCeMercante)"
												class="badge badge-warning tx-11 consulta-ces-badge-ce-atual"
												:title="'CE Mercante atual no processo (será substituído): ' + (p.ceMercante || '')"
											>
												CE atual: {{ p.ceMercante }}
											</span>
											<span
												v-else-if="!consultaCesDigitsOnly(p && p.ceMercante)"
												class="tx-10 tx-danger-500"
												title="Processo sem CE Mercante gravado"
											>
												sem CE
											</span>
											<i
												v-if="consultaCesSyncedIds[p.id]"
												class="tx-16-force fa fa-check tx-success consulta-ces-sync-ok-icon"
												style="color: #00a068"
												aria-hidden="true"
												title="Processo atualizado com este CE"
											></i>
										</div>
									</template>
									<span
										v-else
										class="tx-gray-500 tx-italic"
										title="Nenhum processo pendente: sem BL igual no Gescomex ou todos os que têm este BL já têm CE Mercante (dígitos)"
									>
										Sem processo pendente
									</span>
								</td>
								<td class="consulta-ces-td-cliente va-m">
									<template v-if="linha.processosCompativeis && linha.processosCompativeis.length">
										<div
											v-for="p in linha.processosCompativeis"
											:key="'p-cli-' + linha.nrCeMercante + '-' + p.id"
											class="consulta-ces-cliente-row mg-b-4"
										>
											{{ p.customerName || "—" }}
										</div>
									</template>
									<span v-else class="tx-gray-500">—</span>
								</td>
								<td class="consulta-ces-td-despachante va-m">
									<template v-if="linha.processosCompativeis && linha.processosCompativeis.length">
										<div
											v-for="p in linha.processosCompativeis"
											:key="'p-desp-' + linha.nrCeMercante + '-' + p.id"
											class="consulta-ces-cliente-row mg-b-4"
										>
											{{ p.customBrokerName || "—" }}
										</div>
									</template>
									<span v-else class="tx-gray-500">—</span>
								</td>
								<td class="consulta-ces-td-filial va-m">
									<template v-if="linha.processosCompativeis && linha.processosCompativeis.length">
										<div
											v-for="p in linha.processosCompativeis"
											:key="'p-filial-' + linha.nrCeMercante + '-' + p.id"
											class="consulta-ces-cliente-row mg-b-4"
										>
											{{ p.processAccountLabel || "—" }}
										</div>
									</template>
									<span v-else class="tx-gray-500">—</span>
								</td>
								<td class="consulta-ces-td-acao va-m tx-center">
									<template v-if="linha.processosCompativeis && linha.processosCompativeis.length">
										<div
											v-for="p in linha.processosCompativeis"
											:key="'p-act-' + linha.nrCeMercante + '-' + p.id"
											class="consulta-ces-process-action-row"
										>
											<button
												v-if="linha.nrCeMercante && !consultaCesSyncedIds[p.id]"
												type="button"
												class="btn btn-primary btn-icon rounded-circle consulta-ces-btn-sync-ce"
												title="Gravar o CE-Mercante neste processo e executar sincronização Mercante (containers / AFRMM)."
												aria-label="Atualizar CE-Mercante no processo"
												@click="confirmarAtualizarCeMercante(p, linha.nrCeMercante)"
											>
												<div class="tx-14">
													<i class="fa fa-refresh"></i>
												</div>
											</button>
											<span
												v-else-if="consultaCesSyncedIds[p.id]"
												class="tx-gray-500 tx-11"
												title="Já atualizado"
											>—</span>
											<span v-else class="tx-gray-500">—</span>
										</div>
									</template>
									<span v-else class="tx-gray-500">—</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				</template>
			</div>
		</template>
		<template #footer>
			<div class="consulta-ces-modal-footer">
				<div class="consulta-ces-modal-footer__left">
					<button
						v-if="modalConsultaCesIncluidos.step === 2"
						type="button"
						class="crm-button gray"
						@click.prevent="voltarConsultaCesFormulario"
					>
						Nova consulta
					</button>
					<button
						v-if="
							modalConsultaCesIncluidos.step === 2 &&
							consultaCesTodosPendentesSyncCount > 0
						"
						type="button"
						class="crm-button"
						@click.prevent="confirmarAtualizarTodosProcessosCeMercante"
					>
						Atualizar todos ({{ consultaCesTodosPendentesSyncCount }})
					</button>
				</div>
				<div class="consulta-ces-modal-footer__right">
					<button type="button" class="crm-button red" @click.prevent="closeConsultaCesIncluidosModal">
						Fechar
					</button>
					<button
						v-if="modalConsultaCesIncluidos.step === 1"
						type="button"
						class="crm-button"
						@click.prevent="executarConsultaCesIncluidos"
					>
						Consultar
					</button>
				</div>
			</div>
		</template>
	</VModal>
	<VModal title="Adicionar Cliente" description="" :width="1400" @requestClose="modalContactOpen = false"
		:handler="modalContactOpen">
		<template #content>
			<AddCustomer inModal :redirect="false" @finish="closeCustomerModal" />
		</template>
	</VModal>
  </div>
</template>

<script>
import Axios from "axios";
import config from "@/config.js";
import DatePicker from "vue2-datepicker";
import Drawer from "@/components/Drawer.vue";
import ProcessForm from "@/views/operational/imp/Form.vue";
import ProcessesTable from "@/views/operational/imp/Desk.ProcessesTable.vue";
import DeskStateModal from "@/views/operational/imp/Desk.State.Modal.vue";

import FabMenu from "@/components/FabMenu.vue";

import {mapActions, mapState} from "vuex";
import * as labelsProcesses from "@/labels/labels.processes.js";
import moment from "moment";
import Swal from "sweetalert2";
import {EventBus} from "@/events/EventBus.js";
import MainHeader from "@/components/MainHeader/index.vue";
import TwoSelect from "./TwoSelect";
import VModal from "@/components/VModal.vue";
import MultiSelect from "@/components/MultiSelect.vue";
import * as constants from "@/consts.js";
import * as yup from "yup";
import AddCustomer from "@/components/crm/AddCustomer.vue";
import VInput from "@/components/VInput.vue";
import ProcessService from '@/services/ProcessService.js';
import SALES_RADAR_MODALITIES from '@/utils/salesRadarModalities';

const CONSULTA_CES_LS_ACCOUNT_ID = "desk.consultaCes.lastAccountId";
const CONSULTA_CES_LS_DATA_CONSULTA = "desk.consultaCes.lastDataConsulta";
/** Opção sintética no v-select de unidade: consulta todas as contas com CNPJ/CPF válido. */
const CONSULTA_CES_ALL_ACCOUNT_ID = "__ALL__";

export default {
  name: "operational-importation-desk",
  components: {
    MainHeader,
    "desk-state-modal": DeskStateModal,
    DatePicker,
    Drawer,
    ProcessForm,
    ProcessesTable,
    "two-select": TwoSelect,
    FabMenu,
	VModal,
	MultiSelect,
	AddCustomer,
	VInput,
  },
  data() {
    return {
      modal: {
        deskState: {
          show: false,
        },
      },
	  newProcessPayload: {
		customerRef: null,
		customer: null,
		typeOfProcess: null,
	  },
	  newProcessModal: false,
	  modalContactOpen: false,
	  customers: [],
      mainTitle: "Telão Operacional",
      modelTitle: "Telão Operacional",
      showTable: true,
      showHeader: false,
      showFilterDrawer: false,
      showColumnsDrawer: false,
      showLegendDrawer: false,
      showCompletedProcessesDrawer: false,
      skipNextStepsRouteReload: false,
      showSearch: false,
      searchTerms: "",
      searchColumns: "",
      filter: {
        selectedDateRange: {
          from: "",
          to: "",
        },
        selectedDateField: "",
        selectedTeams: [],
		selectedCustomsTeams: [],
        selectedCustomsBrokers: [],
		selectedImportLicenses: null,
		selectedWaysOfTransport: [],
		selectedIncoterms: [],
		selectedCustomsEnclosuresIds: [],
		selectedDiChannels: [],
		selectedTypesOfProcess: [],
		selectedPriorityTypes: [],
		selectedPriority: null,
		selectedUrgent: null,
		selectedRadarModality: null,
      },
      formFilterConcludedProcesses: {
        dateField: null,
        startDate: null,
        endDate: null,
        customersIds: null,
      },
	  salesRadarModalities: SALES_RADAR_MODALITIES,
	  listOfImportLicenses: [ { id: true , name: "Sim" }, { id: false, name: "Não" } ],
	  listOfPriority: [ { id: true , name: "Sim" }, { id: false, name: "Não" } ],
	  listOfUrgent: [ { id: true , name: "Sim" }, { id: false, name: "Não" } ],
	  listOfIncoterms: constants.OPERATIONAL_INCOTERMS.map((item) => ({id: item.key, name: item.value})),
	  listOfWayOfTransport: constants.OPERATIONAL_WAY_OF_TRANSPORTE.map((item) => ({id: item.key, name: item.value})),
	  listCustomsEnclosures: [],
	  listOfDiChannels: constants.OPERATIONAL_DI_CHANNELS.map((item) => ({id: item.key, name: item.value})),
	  listOfTypeOfProcess: constants.LIST_TYPE_OF_PROCESS.map((item) => ({id: item.key, name: item.value})),
      customersActivesOptions: [],
      processessConcludedFiltered: false,
      findProcessByIdentification: "",
      data: new Array(),
      tableKey: "",
      columnsModel: [
        "identification",
        "step",
        "status",
        "customerRef",
        "customer",
        "acquirer",
        "importer",
        "exporter",
        "manufacturer",
        "seller",
        "customBroker",
        "shipowner",
        "destinationPort",
        "account",
        "importerRef",
        "anotherRef",
		"importLicense",
        "duimp",
		"urgent",
        "invoice",
        "invoiceDate",
        "customBrokerRef",
        "cifValue",
        "cifValueCurrency",
        "processUseOfGoods",
        "fiscalBenefit",
        "fiscalBenefitDescription",
        "icmsDescription",
        "incoterm",
        "wayOfTransport",
        "typeOfBoarding",
        "billOfLading",
        "vehicle",
        "vehicleTranshipment",
        "placeOfLoading",
        "freightForwarder",
        "customsEnclosureURFEntrance",
        "customsEnclosure",
        "conveyor",
        "generalWarehouse",
        "ceMercante",
        "ceMercanteChecked",
        "integrationAFRMMValue",
		"afrmmPaymentDate",
        // "afrmmStatus",
        "stepSpreadsheet",
        "stepInsurance",
        "stepInsuranceSolved",
        "stepInsuranceValue",
        "stepInsuranceValueResponsability",
		"insuranceAward",
        "stepCashRequest",
        "stepCashRequestSolved",
        "originalsDocumentsDate",
        "originalsDocumentsDateSolved",
        "originalsBillOfLadingDate",
        "originalsBillOfLadingDateSolved",
        "originalsInvoiceDate",
        "originalsInvoiceDateSolved",
        "originalsPackingListDate",
        "originalsPackingListDateSolved",
        "conferenceDocumentsSolved",
        "conferencePackingListSolved",
        "conferenceBillOfLadingSolved",
        "conferenceInvoiceSolved",
        "diNumber",
        "diRegistryDate",
        "diTypingDate",
        "diResourcefulnessDate",
        "diChannel",
        "consentingAgency",
        "parameterizationDate",
        "billingNFsDate",
        "billingNFsDateSolved",
        "billingNFsEmissionDate",
        "billingNFsEmissionDateSolved",
        "billingBillCustomerDate",
        "billingBillCustomerDateSolved",
        "billingEmailDate",
        "billingEmailDateSolved",
        "billingSendDate",
        "billingCustomBrokerFinishDate",
        "billingSendCompanyDescription",
        "billingSendTrackingDescription",
        "billingDataConferenceDate",
        "datesEstimatedGoodsReadinesDate",
        "datesETD",
        "datesETA",
        "customerExpectedReceiptDate",
        "datesEstimatedCustomerDeliverDate",
        "datesGoodsReadinesDate",
        "datesDepartureDate",
        "datesArrivalDate",
        "datesGoodsPresenceDate",
        "datesInspectionOfTheDIDate",
        "datesGoodsLoadingDate",
        "datesCustomerDeliverDate",
        "datesInspectionMAPADate",
        "datesInspectionMAPADateSolved",
        "datesReleaseMAPADate",
        "datesReleaseMAPADateSolved",
        "datesLinkInTheEnclosureDate",
        "datesLinkInTheEnclosureDateSolved",
        "datesBillOfLadingReleaseDate",
        "datesSiscargaDate",
        "datesIsThereDTCDTATransfer",
        "datesDTCDTA",
        "datesThereIsDesova",
        "datesEnclosureBillingDate",
        "datesComexDate",
        "created",
        "legacyCreated",
        "freetime",
        "customer.isMinimalComissionPercentual",
        "hasInvoices",
        "documentsSentForExchange",
        "statusCustomBroker",
		"operationStatus",
		"cashRequestDoneDate",
		"cashRequestDone",
		"billOfLadingMaster",
		"booking",
		"voyageNumber",
		"administrativeTreatmentDone",
		"duimpVersion",
		"duimpAccessKey",
		"quantityContainer",
		"priorityTypes",
		"priority",
		"datesEstimatedCargoCollectDate",
		"datesCargoCollectDate",
		"team",
		"financialClosingDebitDueDate",
		"customsTeam",
		"productCatalog",
		"drawback",
      ],
      columnsMirror: [
        "identification",
        "account",
        "step",
		"operationStatus",
		"status",
		"statusCustomBroker",
        "customer",
        "exporter",
		"importLicense",
        "duimp",
        "invoice",
        "customerRef",
        "customsEnclosure",
        "billOfLading",
        "datesETA",
        "datesETD",
        "datesDepartureDate",
        "datesArrivalDate",
      ],
      columns: [
        "identification",
        "account",
        "step",
		"operationStatus",
		"status",
		"statusCustomBroker",
        "customer",
        "exporter",
		"importLicense",
        "duimp",
        "invoice",
        "customerRef",
        "customsEnclosure",
        "billOfLading",
        "datesETA",
        "datesETD",
        "datesDepartureDate",
        "datesArrivalDate",
      ],
      statusFilters: [],
      datesFields: [
        "stepSpreadsheet",
        "stepInsurance",
        "stepCashRequest",
        "originalsDocumentsDate",
        "originalsBillOfLadingDate",
        "originalsInvoiceDate",
        "originalsPackingListDate",
        "diNumber",
        "diRegistryDate",
        "diTypingDate",
        "diResourcefulnessDate",
        "billingNFsDate",
        "billingBillCustomerDate",
        "billingEmailDate",
        "billingSendDate",
        "billingCustomBrokerFinishDate",
        "billingDataConferenceDate",
        "datesEstimatedGoodsReadinesDate",
        "datesETD",
        "datesETA",
        "customerExpectedReceiptDate",
        "datesEstimatedCustomerDeliverDate",
        "datesGoodsReadinesDate",
        "datesDepartureDate",
        "datesArrivalDate",
        "datesGoodsPresenceDate",
        "datesInspectionOfTheDIDate",
        "datesGoodsLoadingDate",
        "datesCustomerDeliverDate",
        "datesInspectionMAPADate",
        "datesReleaseMAPADate",
        "datesLinkInTheEnclosureDate",
        "datesBillOfLadingReleaseDate",
        "datesSiscargaDate",
        "datesDTCDTA",
        "datesThereIsDesova",
        "datesEnclosureBillingDate",
        "datesComexDate",
        "created",
        "legacyCreated",
		"cashRequestDoneDate",
		"datesEstimatedCargoCollectDate",
		"datesCargoCollectDate",
		"financialClosingDebitDueDate",
      ],
      labels: {
        id: {
          label: "ID",
        },
        ...labelsProcesses.reportModifyLabels(),
      },
      customsBrokers: [],
	  listPriorityTypes: [],
      teams: [],
	  customsTeams: [],
      deskStates: [],
      activeDeskStateKey: null,
      keyword: "",
      stepsColumns: {
        /* producao */
        7: [
          "alerts",
          "identification",
          "step",
		  "operationStatus",
          "status",
		  "statusCustomBroker",
          "customerRef",
          "customer",
          "exporter",
		  "importLicense",
          "duimp",
          "invoice",
          "incoterm",
          "typeOfBoarding",
          "stepSpreadsheet",
          "stepInsurance",
          "datesEstimatedGoodsReadinesDate",
        ],
        /* licenciamento */
        11: [
          "alerts",
          "identification",
          "step",
		  "operationStatus",
          "status",
		  "statusCustomBroker",
          "customerRef",
          "customer",
          "exporter",
          "customBroker",
		  "importLicense",
          "duimp",
          "invoice",
          "incoterm",
          "wayOfTransport",
          "typeOfBoarding",
          "billOfLading",
          "freightForwarder",
          "customsEnclosure",
          "stepSpreadsheet",
          "stepInsurance",
          "datesEstimatedGoodsReadinesDate",
          "datesETD",
          "datesETA",
        ],
        /* booking */
        1: [
          "alerts",
          "identification",
          "step",
		  "operationStatus",
          "status",
		  "statusCustomBroker",
          "customerRef",
          "customer",
          "exporter",
          "customBroker",
		  "importLicense",
          "duimp",
          "invoice",
          "incoterm",
          "wayOfTransport",
          "typeOfBoarding",
          "billOfLading",
          "freightForwarder",
          "customsEnclosure",
          "stepSpreadsheet",
          "stepInsurance",
          "datesEstimatedGoodsReadinesDate",
          "datesETD",
          "datesETA",
        ],
        /* transito */
        2: [
          "alerts",
          "identification",
          "step",
		  "operationStatus",
          "status",
		  "statusCustomBroker",
          "customerRef",
          "customer",
          "exporter",
          "customBroker",
		  "importLicense",
          "duimp",
          "invoice",
          "incoterm",
          "typeOfBoarding",
          "billOfLading",
          "vehicle",
          "freightForwarder",
          "customsEnclosure",
          "stepCashRequest",
          "originalsDocumentsDate",
          "datesETA",
          "freetime",
          "datesDepartureDate",
          "datesIsThereDTCDTATransfer",
        ],
        /* desembaraco */
        3: [
          "alerts",
          "identification",
          "step",
		  "operationStatus",
          "status",
		  "statusCustomBroker",
          "customerRef",
          "customer",
          "exporter",
          "customBroker",
		  "importLicense",
          "duimp",
          "invoice",
          "typeOfBoarding",
          "billOfLading",
          "customsEnclosure",
          "conveyor",
          "stepCashRequest",
          "diNumber",
          "diRegistryDate",
          "diChannel",
          "datesArrivalDate",
          "freetime",
          "datesGoodsPresenceDate",
        ],
        /* carregamento */
        4: [
          "alerts",
          "identification",
          "step",
		  "operationStatus",
          "status",
		  "statusCustomBroker",
          "customerRef",
          "customer",
          "exporter",
		  "importLicense",
          "duimp",
          "invoice",
          "typeOfBoarding",
          "customsEnclosure",
          "conveyor",
          "diResourcefulnessDate",
          "billingNFsDate",
          "billingNFsEmissionDate",
          "datesArrivalDate",
          "freetime",
          "datesSiscargaDate",
          "datesComexDate",
        ],
        /* encerramento */
        5: [
          "alerts",
          "identification",
          "step",
          "customer",
		  "operationStatus",
          "status",
		  "typeOfBoarding",
          "customBroker",
		  "freightForwarder",
          "customsEnclosure",
		  "conveyor",
		  "stepInsuranceValueResponsability",
		  "revenuesReleaseBLAWBState",
          "revenuesStorageState",
          "revenuesTransportState",
          "revenuesOtherExpenses",
		  "datesCustomerDeliverDate",
		  "cashRequestDone",
          "billingTerm",
          "expectedDeliveryTime",
        ],
        /* pendencias */
        10: [
          "alerts",
          "identification",
          "step",
		  "operationStatus",
          "status",
		  "statusCustomBroker",
          "customerRef",
          "customer",
          "exporter",
		  "importLicense",
          "duimp",
          "invoice",
          "incoterm",
          "typeOfBoarding",
          "conveyor",
        ],
        /* concluido */
        6: [
          "alerts",
          "identification",
          "step",
		  "operationStatus",
          "status",
		  "statusCustomBroker",
          "customerRef",
          "customer",
          "exporter",
		  "importLicense",
          "duimp",
          "invoice",
          "incoterm",
          "typeOfBoarding",
          "billOfLading",
          "diNumber",
          "diResourcefulnessDate",
          "diChannel",
          "billingBillCustomerDate",
          "datesDepartureDate",
          "datesArrivalDate",
          "datesGoodsLoadingDate",
          "datesCustomerDeliverDate",
        ],
        /* cancelamento */
        9: [
          "alerts",
          "identification",
          "step",
		  "operationStatus",
          "status",
		  "statusCustomBroker",
          "customerRef",
          "customer",
          "exporter",
		  "importLicense",
          "duimp",
          "invoice",
          "incoterm",
          "typeOfBoarding",
          "billOfLading",
          "datesDepartureDate",
          "datesArrivalDate",
          "billOfLading",
          "diNumber",
          "diResourcefulnessDate",
          "diChannel",
          "datesGoodsLoadingDate",
          "datesCustomerDeliverDate",
          "billingBillCustomerDate",
        ],
      },
      changeToDefaultColumns: true,
	  formErrors: [],
      modalConsultaCesIncluidos: {
        open: false,
        step: 1,
      },
      consultaCesForm: {
        dataConsultaDate: null,
      },
      consultaCesSelectedAccount: null,
      consultaCesAccountsList: [],
      consultaCesAccountsLoading: false,
      consultaCesLinhas: [],
      consultaCesResumo: {},
      /** processId -> true após sync CE com sucesso nesta sessão do modal */
      consultaCesSyncedIds: {},
      consultaCesFilterText: "",
      consultaCesErroConsulta: null,
      deskTableFlashProcessId: null,
      consultaCesAllAccountId: CONSULTA_CES_ALL_ACCOUNT_ID,
    };
  },
  computed: {
    ...mapState({
      steps: (state) => state.ProcessStore.steps.filter((step) => {
        return !(step.id === 11 && !(config.env.API_DEFAULT.host === "http://localhost:7777" || config.env.API_DEFAULT.host === "http://dev.webservice.gscmx.prime.com.vc:7777"));
      }),
      processes: (state) => state.ProcessStore.processes,
      allProcesses: (state) => state.ProcessStore.allProcesses,
      process: (state) => state.ProcessStore.activeProcess,
      showProcess: (state) => state.ProcessStore.showProcess,
      processesFilterIds: (state) => state.ProcessStore.processesFilterIds,
      stateSteps: (state) => state.ProcessStore.stateSteps,
      stateColumns: (state) => state.ProcessStore.stateColumns,
      socket: (state) => state.ProcessStore.socket,
      openedProcesses: (state) => state.ProcessStore.openedProcesses,
      credentials: (state) => state.credentials,
    }),

    listOfDatesFields() {

      const data = new Array();

      if (this.labels !== undefined) {
        for (const prop in this.labels) {
          if (this.labels[prop].type === "date") {
            data.push(this.labels[prop]);
          }
        }
      }

      data.push(
        {
          attribute: "productCatalogDate",
          label: "Catálogo",
          type: "date",
        },
        {
          attribute: "administrativeTreatmentDoneDate",
          label: "TA Feito",
          type: "date",
        }
      );

      return data;

    //   const data = new Array();

    //   this.datesFields.forEach((item) => {
    //     const itemContent = this.labels[item];

    //     if (itemContent.type === "date") {
    //       data.push({
    //         label: itemContent.label,
    //         attribute: itemContent.attribute,
    //       });
    //     }
    //   });

    //   return data;
    },

    listColumnsModel() {
      return this.columnsModel.filter((item) => {
        const itemContent = this.labels[item];
        if (itemContent.label !== undefined) {
          return (
            itemContent.label
              .toLowerCase()
              .indexOf(this.searchColumns.toLowerCase()) > -1
          );
        }

        return false;
      });
    },
	selectedFiltersCount() {
		let count = 0;
		if (this.filter.selectedDateRange.from || this.filter.selectedDateRange.to ||this.filter.selectedDateField) count++;
		if (this.filter.selectedTeams.length) count++;
		if (this.filter.selectedCustomsTeams?.length) count++;
		if (this.filter.selectedCustomsBrokers.length) count++;
		if (this.filter.selectedImportLicenses) count++;
		if (this.filter.selectedWaysOfTransport?.length) count++;
		if (this.filter.selectedIncoterms?.length) count++;
		if (this.filter.selectedCustomsEnclosuresIds?.length) count++;
		if (this.filter.selectedDiChannels?.length) count++;
		if (this.filter.selectedTypesOfProcess?.length) count++;
		if (this.filter.selectedPriorityTypes?.length) count++;
		if (this.filter.selectedRadarModality && this.filter.selectedRadarModality?.value) count++;
		if (this.filter.selectedPriority) count++;
		if (this.filter.selectedUrgent) count++;
		return count;
	},

    consultaCesAccountsActive() {
      const list = this.consultaCesAccountsList || [];
      return list.filter((a) => a && a.enabled === true);
    },
    /** Unidade + opção sintética "TODOS" no topo. */
    consultaCesUnidadeSelectOptions() {
      const optAll = {
        id: CONSULTA_CES_ALL_ACCOUNT_ID,
        name: "TODOS",
        federalID: null,
        enabled: true,
      };
      return [optAll].concat(this.consultaCesAccountsActive || []);
    },
    consultaCesIsAllUnidadesSelected() {
      const a = this.consultaCesSelectedAccount;
      return !!(a && String(a.id) === CONSULTA_CES_ALL_ACCOUNT_ID);
    },
    /** Contas ativas com CNPJ/CPF de importador válido (11 ou 14 dígitos). */
    consultaCesAccountsComCnpjImportadorValido() {
      return (this.consultaCesAccountsActive || []).filter((a) => {
        const d = String((a && a.federalID) || "").replace(/\D/g, "");
        return d.length === 11 || d.length === 14;
      });
    },

    /** Passo 1: modal compacto; passo 2: largura/altura amplas para a tabela */
    consultaCesModalWidth() {
      return this.modalConsultaCesIncluidos.step === 1 ? 820 : 1680;
    },
    consultaCesModalHeight() {
      return this.modalConsultaCesIncluidos.step === 1 ? 42 : 90;
    },
    consultaCesModalClassModify() {
      const base = "remove-overflow consulta-ces-vmodal";
      return this.modalConsultaCesIncluidos.step === 1
        ? `${base} consulta-ces-vmodal--form`
        : `${base} consulta-ces-vmodal--result`;
    },

    consultaCesLinhasFiltradas() {
      const lines = this.consultaCesLinhas || [];
      const q = (this.consultaCesFilterText || "").trim().toLowerCase();
      if (!q) {
        return lines;
      }
      return lines.filter((l) => {
        if (!l) {
          return false;
        }
        const procText = (l.processosCompativeis || [])
          .map((p) =>
            [
              p && p.formattedReference,
              p && p.identification,
              p && p.customerName,
              p && p.ceMercante,
              p && p.customBrokerName,
              p && p.processAccountLabel,
            ]
              .filter(Boolean)
              .join(" ")
          )
          .join(" ");
        const hay = [
          l.nrCeMercante,
          l.numeroBl,
          l.tipo,
          l.numeroManifesto,
          l.dataOperacao,
          l.embarcacao,
          l.portoCarregamento,
          l.portoDescarregamento,
          procText,
        ]
          .filter((x) => x != null && String(x).trim() !== "")
          .join(" ")
          .toLowerCase();
        return hay.indexOf(q) !== -1;
      });
    },

    /**
     * Pares { processo, ce } ainda não sincronizados nesta sessão, em todas as linhas da consulta
     * (não depende do filtro da tabela). Cada id de processo entra uma vez — CE da primeira linha em que aparece.
     */
    consultaCesTodosPendentesSync() {
      const byId = new Map();
      const linhas = this.consultaCesLinhas || [];
      for (let i = 0; i < linhas.length; i++) {
        const linha = linhas[i];
        const ce =
          linha && linha.nrCeMercante != null ? String(linha.nrCeMercante).trim() : "";
        if (!ce) {
          continue;
        }
        const procs = (linha && linha.processosCompativeis) || [];
        for (let j = 0; j < procs.length; j++) {
          const p = procs[j];
          if (!p || p.id == null) {
            continue;
          }
          if (this.consultaCesSyncedIds[p.id]) {
            continue;
          }
          if (!byId.has(p.id)) {
            byId.set(p.id, { processo: p, ce });
          }
        }
      }
      return Array.from(byId.values());
    },
    consultaCesTodosPendentesSyncCount() {
      return this.consultaCesTodosPendentesSync.length;
    },

    /** Passo 2: totais derivados da grade filtrada (CEs distintos × processos distintos na mesa). */
    consultaCesResultadoResumoNumeros() {
      const linhas = this.consultaCesLinhasFiltradas;
      const ceSet = new Set();
      linhas.forEach((l) => {
        const ce = l && l.nrCeMercante != null ? String(l.nrCeMercante).trim() : "";
        if (ce) ceSet.add(ce);
      });
      const nCes = ceSet.size > 0 ? ceSet.size : linhas.length;

      const procSet = new Set();
      linhas.forEach((l) => {
        const arr = (l && l.processosCompativeis) || [];
        arr.forEach((p) => {
          if (p && p.id != null) procSet.add(p.id);
        });
      });

      return { nCes, nProc: procSet.size };
    },
    consultaCesResultadoDataExibicao() {
      const r = this.consultaCesResumo || {};
      if (r.conhecimentosIncluidosDataPesquisada) {
        return String(r.conhecimentosIncluidosDataPesquisada).trim();
      }
      const d = this.consultaCesForm && this.consultaCesForm.dataConsultaDate;
      if (!d) {
        return "";
      }
      const m = moment(d, "YYYY-MM-DD", true);
      return m.isValid() ? m.format("DD/MM/YYYY") : moment(d).format("DD/MM/YYYY");
    },
    consultaCesResultadoCnpjExibicao() {
      const acc = this.consultaCesSelectedAccount;
      if (!acc) {
        return "";
      }
      const raw = acc.federalID != null ? String(acc.federalID).trim() : "";
      return raw || "";
    },
    /** Texto da linha de meta (CNPJ único ou "todas as unidades"). */
    consultaCesResultadoUnidadeMeta() {
      if (this.consultaCesIsAllUnidadesSelected) {
        const n = this.consultaCesAccountsComCnpjImportadorValido.length;
        return n ? "Todas as unidades (" + n + " CNPJ/CPF)" : "Todas as unidades";
      }
      return this.consultaCesResultadoCnpjExibicao || "";
    },
    activeDeskState() {
      if (!this.activeDeskStateKey) return null;

      return (
        this.deskStates.find(
          (state) => this.getDeskStateKey(state) === this.activeDeskStateKey
        ) || null
      );
    },
    profileButtonLabel() {
      if (this.activeDeskState && this.activeDeskState.name) {
        return `Perfil: ${this.activeDeskState.name}`;
      }

      return "Perfil";
    },
    profileButtonTitle() {
      if (this.activeDeskState && this.activeDeskState.name) {
        return `Perfil ativo: ${this.activeDeskState.name}`;
      }

      return "Perfil";
    },
  },
  methods: {
    ...mapActions("ProcessStore", [
      "setProcessesFilterIds",
      "getStateSteps",
      "getStateColumns",
      "connectWs",
    ]),
	closeCompletedProcessesDrawer() {
		this.showCompletedProcessesDrawer = false;
		this.formFilterConcludedProcesses = {
			dateField: null,
			startDate: null,
			endDate: null,
			customersIds: null,
		};
	},
    syncSelectedCustomsTeamsWithOptions() {
      if (!this.filter || !this.customsTeams || !this.customsTeams.length) {
        return;
      }
      const sel = this.filter.selectedCustomsTeams;
      if (!sel || !sel.length) {
        return;
      }
      this.filter.selectedCustomsTeams = sel
        .map((item) => {
          const id = typeof item === "object" && item !== null ? item.id : item;
          return this.customsTeams.find((o) => o.id === id);
        })
        .filter(Boolean);
    },
    getError(field) {
      if (this.formErrors.length > 0) {
        const item = this.formErrors.find((e) => e.path === field || e.type === field);
        if (item && item.message) {
          return this.formErrors.find((e) => e.path === field || e.type === field).message;
        }
      } else {
        return null;
      }
    },
	schema() {
      let schema = yup.object().shape({
        customerId: yup.string().required("O Cliente é obrigatório!"),
        typeOfProcess: yup.string().required("O Tipo de Processo é obrigatório!"),
      });
      return schema;
    },
	async closeCustomerModal(customer = null) {
		if (customer != null) {
			await this.findActiveCustomers();
			this.newProcessPayload.customer = {
				label: customer.completeName,
				attribute: customer.id,
			};
		}
		this.modalContactOpen = false;
	},
	reloadProcesses(value) {
      // this.searchProcesses('searchFilterComplete')
      // this.loadProcesses(this.$router.currentRoute.query.stepsIds);
    },
    async openConsultaCesIncluidosModal() {
      this.modalConsultaCesIncluidos.open = true;
      this.modalConsultaCesIncluidos.step = 1;
      this.consultaCesLinhas = [];
      this.consultaCesResumo = {};
      this.consultaCesSyncedIds = {};
      this.consultaCesFilterText = "";
      this.consultaCesErroConsulta = null;
      this.consultaCesForm = {
        dataConsultaDate: moment().format("YYYY-MM-DD"),
      };
      this.consultaCesSelectedAccount = null;
      await this.fetchConsultaCesAccounts();
      this.selectDefaultConsultaCesAccount();
    },
    /** Última unidade e data usadas (localStorage), senão primeira unidade ativa. */
    selectDefaultConsultaCesAccount() {
      const list = this.consultaCesAccountsActive || [];
      if (!list.length) {
        return;
      }
      let found = null;
      try {
        const rawId = localStorage.getItem(CONSULTA_CES_LS_ACCOUNT_ID);
        if (rawId === CONSULTA_CES_ALL_ACCOUNT_ID) {
          const opts = this.consultaCesUnidadeSelectOptions;
          this.consultaCesSelectedAccount = opts.length ? opts[0] : list[0];
          try {
            const savedDate = localStorage.getItem(CONSULTA_CES_LS_DATA_CONSULTA);
            if (savedDate && /^\d{4}-\d{2}-\d{2}$/.test(savedDate)) {
              this.consultaCesForm.dataConsultaDate = savedDate;
            }
          } catch (e) {
            /* ignore */
          }
          return;
        }
        if (rawId) {
          found = list.find((a) => String(a.id) === String(rawId));
        }
      } catch (e) {
        found = null;
      }
      this.consultaCesSelectedAccount = found || list[0];
      try {
        const savedDate = localStorage.getItem(CONSULTA_CES_LS_DATA_CONSULTA);
        if (savedDate && /^\d{4}-\d{2}-\d{2}$/.test(savedDate)) {
          this.consultaCesForm.dataConsultaDate = savedDate;
        }
      } catch (e) {
        /* ignore */
      }
    },
    consultaCesPersistLastChoices() {
      const acc = this.consultaCesSelectedAccount;
      try {
        if (acc && acc.id != null) {
          localStorage.setItem(CONSULTA_CES_LS_ACCOUNT_ID, String(acc.id));
        }
        const d = this.consultaCesForm && this.consultaCesForm.dataConsultaDate;
        if (d) {
          localStorage.setItem(CONSULTA_CES_LS_DATA_CONSULTA, d);
        }
      } catch (e) {
        /* ignore private mode / quota */
      }
    },
    voltarConsultaCesFormulario() {
      this.modalConsultaCesIncluidos.step = 1;
      this.consultaCesLinhas = [];
      this.consultaCesResumo = {};
      this.consultaCesSyncedIds = {};
      this.consultaCesFilterText = "";
      this.consultaCesErroConsulta = null;
    },
    tentarNovamenteConsultaCesIncluidos() {
      this.consultaCesErroConsulta = null;
      this.executarConsultaCesIncluidos();
    },
    consultaCesDigitsOnly(value) {
      if (value == null) {
        return "";
      }
      const s = String(value);
      let out = "";
      for (let i = 0; i < s.length; i++) {
        const c = s.charAt(i);
        if (c >= "0" && c <= "9") {
          out += c;
        }
      }
      return out;
    },
    /** Só processos sem CE Mercante com dígitos (igual à Base API / tela de pendências). */
    consultaCesFiltrarLinhasSoPendentesSemCe(linhas) {
      if (!linhas || !linhas.length) {
        return linhas || [];
      }
      return linhas.map((l) => ({
        ...l,
        processosCompativeis: (l.processosCompativeis || []).filter(
          (p) => p && p.id != null && this.consultaCesDigitsOnly(p.ceMercante) === ""
        ),
      }));
    },
    consultaCesProcessoCeDivergeDoLinha(processo, nrCeLinha) {
      const proc = this.consultaCesDigitsOnly(processo && processo.ceMercante);
      const line = this.consultaCesDigitsOnly(nrCeLinha);
      if (!line || !proc) {
        return false;
      }
      return proc !== line;
    },
    consultaCesLinhaBulkCount(linha) {
      const ce = linha && linha.nrCeMercante != null ? String(linha.nrCeMercante).trim() : "";
      if (!ce) {
        return 0;
      }
      const arr = (linha && linha.processosCompativeis) || [];
      return arr.filter((p) => p && p.id != null && !this.consultaCesSyncedIds[p.id]).length;
    },
    consultaCesEmitWebsocketFromSync(pid, ce, updated) {
      if (!this.socket || this.socket.readyState !== 1) {
        return;
      }
      const payload = { ceMercante: ce };
      if (updated && typeof updated === "object") {
        if (updated.integrationAFRMMValue !== undefined) {
          payload.integrationAFRMMValue = updated.integrationAFRMMValue;
        }
        if (updated.containers !== undefined) {
          payload.containers = updated.containers;
        }
      }
      Object.keys(payload).forEach((fieldName) => {
        this.socket.send(
          JSON.stringify({
            action: config.env.WEBSOCKET.actions.UPDATE_PROC,
            data: {
              [pid]: {
                [fieldName]: payload[fieldName],
              },
            },
          })
        );
      });
    },
    consultaCesApplySyncForProcess(processo, nrCeMercante) {
      const base = config.env.API_DEFAULT.host;
      const pid = processo.id;
      const ce = String(nrCeMercante).trim();
      return Axios.patch(`${base}/importProcesses/${pid}`, { ceMercante: ce })
        .then(() => Axios.post(`${base}/newImportProcess/${pid}/sync-ce-mercante`))
        .then((syncRes) => {
          this.$set(this.consultaCesSyncedIds, pid, true);
          const updated = syncRes.data && syncRes.data.data;
          this.consultaCesEmitWebsocketFromSync(pid, ce, updated);
          return syncRes;
        });
    },
    scrollDeskFlashProcessRow(pid) {
      this.deskTableFlashProcessId = pid;
      this.$nextTick(() => {
        const el = document.getElementById("desk-row-process-" + pid);
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        window.setTimeout(() => {
          if (this.deskTableFlashProcessId === pid) {
            this.deskTableFlashProcessId = null;
          }
        }, 4500);
      });
    },
    async fetchConsultaCesAccounts() {
      this.consultaCesAccountsLoading = true;
      try {
        const res = await Axios.get(`${config.env.API_DEFAULT.host}/accounts`);
        const embedded = res.data && res.data._embedded;
        this.consultaCesAccountsList =
          embedded && embedded.accounts ? embedded.accounts : [];
      } catch (e) {
        this.consultaCesAccountsList = [];
        Swal.fire(
          "Unidades da empresa",
          "Não foi possível carregar as unidades. Verifique sua conexão ou permissões.",
          "error"
        );
      } finally {
        this.consultaCesAccountsLoading = false;
      }
    },
    closeConsultaCesIncluidosModal() {
      this.modalConsultaCesIncluidos.open = false;
    },
    consultaCesLineKey(linha) {
      if (!linha) {
        return "";
      }
      const ce = this.consultaCesDigitsOnly(linha.nrCeMercante);
      const bl = (linha.numeroBl != null ? String(linha.numeroBl) : "").trim().toLowerCase();
      return ce + "|" + bl;
    },
    consultaCesMergeLinhas(existing, incoming) {
      const map = new Map();
      const mergeOne = (l) => {
        if (!l) {
          return;
        }
        const k = this.consultaCesLineKey(l);
        if (!map.has(k)) {
          map.set(k, {
            ...l,
            processosCompativeis: [].concat(l.processosCompativeis || []),
          });
          return;
        }
        const cur = map.get(k);
        const byId = new Map();
        (cur.processosCompativeis || []).forEach((p) => {
          if (p && p.id != null) {
            byId.set(p.id, p);
          }
        });
        (l.processosCompativeis || []).forEach((p) => {
          if (p && p.id != null && !byId.has(p.id)) {
            byId.set(p.id, p);
          }
        });
        cur.processosCompativeis = Array.from(byId.values());
      };
      (existing || []).forEach(mergeOne);
      (incoming || []).forEach(mergeOne);
      return Array.from(map.values());
    },
    async executarConsultaCesIncluidos() {
      this.consultaCesErroConsulta = null;
      const acc = this.consultaCesSelectedAccount;
      if (!acc || acc.id == null) {
        Swal.fire("Atenção", "Selecione a unidade da empresa (CNPJ do importador).", "warning");
        return;
      }
      const allSelected = String(acc.id) === CONSULTA_CES_ALL_ACCOUNT_ID;
      let accountsToQuery = [];
      if (allSelected) {
        accountsToQuery = this.consultaCesAccountsComCnpjImportadorValido;
        if (!accountsToQuery.length) {
          Swal.fire(
            "Atenção",
            "Nenhuma unidade habilitada com CNPJ/CPF válido (11 ou 14 dígitos). Ajuste em Configurações → Unidades da Empresa.",
            "warning"
          );
          return;
        }
      } else {
        const cnpj = String(acc.federalID || "").replace(/\D/g, "");
        if (!cnpj || (cnpj.length !== 11 && cnpj.length !== 14)) {
          Swal.fire(
            "Atenção",
            "O CNPJ/CPF cadastrado na unidade selecionada é inválido. Ajuste em Configurações → Unidades da Empresa.",
            "warning"
          );
          return;
        }
        accountsToQuery = [acc];
      }
      this.consultaCesPersistLastChoices();
      const base = config.env.API_DEFAULT.host;
      const url = `${base}/newImportProcess/mercante/consulta-conhecimentos-incluidos`;
      const d = this.consultaCesForm.dataConsultaDate;
      let dtConsulta = null;
      if (d) {
        const m = moment(d, "YYYY-MM-DD", true);
        dtConsulta = m.isValid() ? m.format("DD/MM/YYYY") : moment(d).format("DD/MM/YYYY");
      }
      this.$store.commit("setLoading", {
        show: true,
        label: "Consultando CEs incluídos",
        description: allSelected
          ? `Unidade 0 de ${accountsToQuery.length}…`
          : "Comunicando com o Goods / Marinha (pode levar até ~1 min em caso de lentidão)...",
      });
      try {
        let mergedLinhas = [];
        let mergedResumo = {};
        const totalAcc = accountsToQuery.length;
        for (let i = 0; i < totalAcc; i++) {
          const unit = accountsToQuery[i];
          const cnpj = String(unit.federalID || "").replace(/\D/g, "");
          if (allSelected) {
            this.$store.commit("setLoading", {
              show: true,
              label: "Consultando CEs incluídos",
              description: `Unidade ${i + 1} de ${totalAcc}…`,
            });
          }
          const payload = {
            cnpjCpfImportador: cnpj,
            persist: true,
          };
          if (dtConsulta) {
            payload.dtConsulta = dtConsulta;
          }
          const res = await Axios.post(url, payload);
          const body = res.data && res.data.data;
          const linhas = this.consultaCesFiltrarLinhasSoPendentesSemCe(
            body && body.linhas ? body.linhas : []
          );
          mergedLinhas = this.consultaCesMergeLinhas(mergedLinhas, linhas);
          if (i === 0 && body && body.resumoGoods) {
            mergedResumo = body.resumoGoods;
          }
        }
        this.consultaCesSyncedIds = {};
        this.consultaCesLinhas = this.consultaCesFiltrarLinhasSoPendentesSemCe(mergedLinhas);
        this.consultaCesResumo = mergedResumo;
        this.consultaCesFilterText = "";
        this.modalConsultaCesIncluidos.step = 2;
      } catch (e) {
        let msg =
          e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : e.message;
        const low = (msg || "").toLowerCase();
        if (low.indexOf("timeout") !== -1 || low.indexOf("timed out") !== -1) {
          msg +=
            " Se o problema persistir, aguarde alguns minutos ou tente outro horário; a integração pode estar lenta.";
        }
        this.consultaCesErroConsulta = msg;
        Swal.fire({
          title: "Erro na consulta",
          html: `<p class="tx-left mg-b-0">${msg}</p>`,
          type: "error",
          confirmButtonText: "OK",
        });
      } finally {
        this.$store.commit("setLoading", { show: false });
      }
    },
    confirmarAtualizarCeMercante(processo, nrCeMercante) {
      if (!processo || !processo.id || !nrCeMercante) {
        return;
      }
      const ref = processo.formattedReference || processo.identification || processo.id;
      const ce = String(nrCeMercante).trim();
      Swal.fire({
        title: "Atualizar processo?",
        html: `<p>Será salvo o CE Mercante <strong>${ce}</strong> no processo <strong>${ref}</strong> e executada a sincronização (Containers / Taxas AFRMM).</p>`,
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.value) {
          return;
        }
        this.$store.commit("setLoading", {
          show: true,
          label: "Atualizando processo",
          description: "Gravando CE e sincronizando...",
        });
        const pid = processo.id;
        this.consultaCesApplySyncForProcess(processo, nrCeMercante)
          .then(() => {
            Swal.fire("Sucesso", "Processo atualizado.", "success");
            this.newSearchProcesses();
            this.scrollDeskFlashProcessRow(pid);
          })
          .catch((err) => {
            const msg =
              err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : err.message;
            Swal.fire("Erro", msg, "error");
          })
          .finally(() => {
            this.$store.commit("setLoading", { show: false });
          });
      });
    },
    confirmarBulkAtualizarCeMercante(linha) {
      const ce = linha && linha.nrCeMercante != null ? String(linha.nrCeMercante).trim() : "";
      const procs = ((linha && linha.processosCompativeis) || []).filter(
        (p) => p && p.id != null && !this.consultaCesSyncedIds[p.id]
      );
      if (!ce || procs.length < 2) {
        return;
      }
      const refs = procs
        .map((p) => p.formattedReference || p.identification || p.id)
        .join(", ");
      Swal.fire({
        title: "Sincronizar vários processos?",
        html: `<p class="tx-left mg-b-0">Será gravado o CE <strong>${ce}</strong> e executada a sincronização em <strong>${procs.length}</strong> processo(s):</p><p class="tx-left tx-12 mg-t-8">${refs}</p>`,
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Confirmar todos",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (!result.value) {
          return;
        }
        this.$store.commit("setLoading", {
          show: true,
          label: "Sincronizando processos",
          description: `0 / ${procs.length}`,
        });
        let lastPid = null;
        try {
          for (let i = 0; i < procs.length; i++) {
            this.$store.commit("setLoading", {
              show: true,
              label: "Sincronizando processos",
              description: `${i + 1} / ${procs.length}`,
            });
            await this.consultaCesApplySyncForProcess(procs[i], ce);
            lastPid = procs[i].id;
          }
          Swal.fire("Sucesso", `${procs.length} processo(s) atualizado(s).`, "success");
          this.newSearchProcesses();
          if (lastPid != null) {
            this.scrollDeskFlashProcessRow(lastPid);
          }
        } catch (err) {
          const msg =
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : err.message;
          Swal.fire("Erro", msg, "error");
        } finally {
          this.$store.commit("setLoading", { show: false });
        }
      });
    },
    confirmarAtualizarTodosProcessosCeMercante() {
      const items = this.consultaCesTodosPendentesSync;
      if (!items.length) {
        return;
      }
      const maxRefs = 18;
      const refsPreview = items
        .slice(0, maxRefs)
        .map(
          (it) =>
            `${it.processo.formattedReference || it.processo.identification || it.processo.id} → CE ${it.ce}`
        )
        .join("<br>");
      const more =
        items.length > maxRefs
          ? `<p class="tx-11 text-muted mg-t-8 mg-b-0">… e mais ${items.length - maxRefs} processo(s).</p>`
          : "";
      Swal.fire({
        title: "Atualizar todos os processos pendentes?",
        html: `<p class="tx-left mg-b-0">Será gravado o CE Mercante de cada linha e executada a sincronização (containers / AFRMM) em <strong>${items.length}</strong> processo(s) ainda pendentes nesta consulta.</p><p class="tx-left tx-12 mg-t-10 mg-b-0">${refsPreview}</p>${more}`,
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Confirmar todos",
        cancelButtonText: "Cancelar",
        width: 560,
      }).then(async (result) => {
        if (!result.value) {
          return;
        }
        this.$store.commit("setLoading", {
          show: true,
          label: "Sincronizando todos os processos",
          description: `0 / ${items.length}`,
        });
        let lastPid = null;
        try {
          for (let i = 0; i < items.length; i++) {
            this.$store.commit("setLoading", {
              show: true,
              label: "Sincronizando todos os processos",
              description: `${i + 1} / ${items.length}`,
            });
            const it = items[i];
            await this.consultaCesApplySyncForProcess(it.processo, it.ce);
            lastPid = it.processo.id;
          }
          Swal.fire("Sucesso", `${items.length} processo(s) atualizado(s).`, "success");
          this.newSearchProcesses();
          if (lastPid != null) {
            this.scrollDeskFlashProcessRow(lastPid);
          }
        } catch (err) {
          const msg =
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : err.message;
          Swal.fire("Erro", msg, "error");
        } finally {
          this.$store.commit("setLoading", { show: false });
        }
      });
    },
    async abrirProcessoDesdeConsultaCes(proc) {
      if (!proc || proc.id == null) {
        return;
      }
      try {
        const response = await this.$store.dispatch("ProcessStore/findProcessById", proc.id);
        this.$store.commit("setLoading", { show: false });
        if (!response || !response.success) {
          let msg = "Não foi possível abrir o processo.";
          if (response && response.error) {
            const er = response.error;
            if (er.response && er.response.data && er.response.data.message) {
              msg = er.response.data.message;
            } else if (er.message) {
              msg = er.message;
            }
          }
          Swal.fire("Processo", msg, "error");
          return;
        }
        this.$router.push({
          query: { ...this.$route.query, showProcess: "true" },
        });
      } catch (error) {
        this.$store.commit("setLoading", { show: false });
        const msg =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
            ? error.response.data.message
            : error && error.message
              ? error.message
              : "Erro ao abrir o processo.";
        Swal.fire("Processo", msg, "error");
      }
    },
    closeModalDeskState(type) {
      this.modal.deskState.show = false;
    },
    toggleHeader() {
      this.showHeader = !this.showHeader;
    },
    async checkActiveStep(step) {
      const stateSteps = await this.getStateSteps();

      return stateSteps.includes(step);
    },
    async findActiveCustomers() {
      try {
		this.customersActivesOptions = [];
        const response = await Axios.get(
          `${config.env.API_DEFAULT.host}/company/findAllActives`
        );

        if (response.data.data) {
          response.data.data.forEach((customer) => {
            if (customer.isCustomer) {
              this.customersActivesOptions.push({
                label: customer.completeName,
                attribute: customer.id,
              });
            }
          });
        }
      } catch (e) {
        Swal.fire(
          "Filtrar processos concluídos",
          "Erro ao buscar clientes ativos!",
          "error"
        );
      }
    },
    async submitFilterConcludedProcesses() {
      if (
        this.formFilterConcludedProcesses.dateField == null ||
        this.formFilterConcludedProcesses.startDate == null
      ) {
        Swal.fire(
          "Filtrar processos concluídos",
          "Você precisa informar um campo de data e um período para efetuar o filtro!",
          "error"
        );

        // this.showCompletedProcessesDrawer = false;
      } else {
        this.$store.commit("setLoading", {
          show: true,
          label: "Estado da Mesa",
          description: "Carregandos os processos concluídos...",
        });

        try {
          const startDate = `${moment(
            this.formFilterConcludedProcesses.startDate
          ).format("YYYY-MM-DD")}`;

          const endDate = null;

          if (this.formFilterConcludedProcesses.endDate) {
            const endDate = `${moment(
              this.formFilterConcludedProcesses.endDate
            ).format("YYYY-MM-DD")}`;
          }

          let customersIds = null;

          if (
            this.formFilterConcludedProcesses.customersIds &&
            this.formFilterConcludedProcesses.customersIds.length > 0
          ) {
            customersIds = this.formFilterConcludedProcesses.customersIds
              .map((item) => item.attribute)
              .join(",");
          }

          let url = `${config.env.API_DEFAULT.host}/newImportProcess?steps=6&columns=customer,forwarder,conveyor,customBroker,manufacturer&startDate=${startDate}&dateField=${this.formFilterConcludedProcesses.dateField.attribute}`;

          if (endDate != null) {
            alert(endDate);
            url += `&endDate=${endDate}`;
          }

          if (customersIds != null) {
            url += `&customersIds=${customersIds}`;
          }

          const response = await Axios.post(url);

          this.$store.commit("ProcessStore/SET_FILTERED_PROCESSES", []);
          this.$store.commit("ProcessStore/SET_PROCESSES", response.data.data);

          this.$store.commit("setLoading", {
            show: false,
          });

          Swal.fire(
            "Telão Operacional",
            "Processos concluídos filtrados com sucesso!",
            "success"
          );

          this.columns = this.stepsColumns[6];

          this.formFilterConcludedProcesses = {
            dateField: null,
            startDate: null,
            endDate: null,
            customersIds: null,
          };

          this.showCompletedProcessesDrawer = false;
        } catch (e) {
          Swal.fire(
            "Telão Operacional",
            `Houve algum problema ao tentar carregar os processos: ${e}`,
            "error"
          );

          this.$store.commit("setLoading", {
            show: false,
          });
        }
      }
    },
    async loadProcesses(steps = "") {
      this.$store.commit("setLoading", {
        show: true,
        label: "Aguarde...",
        description: "Preparando os processos para a operação...",
      });

      try {
        const response = await this.$store.dispatch("ProcessStore/getSteps");

        if (response !== undefined && response && response.success) {

          if (!steps && steps === "") {
			  steps = this.$route.query.stepsIds;
          }

		  if (steps) {
				const validations = [
					{
						condition: () => !this.filter.selectedDateRange.from && this.filter.selectedDateRange.to,
						message: "Você precisa preencher a <b>Data Inicial</b>."
					},
					{
						condition: () => this.filter.selectedDateRange.from && !this.filter.selectedDateRange.to,
						message: "Você precisa preencher a <b>Data Final</b>."
					},
					{
						condition: () => this.filter.selectedDateRange.from && 
										this.filter.selectedDateRange.to && 
										!this.filter.selectedDateField,
						message: "Você precisa selecionar o <b>Campo do Filtro</b> dos Filtros Diponíveis para que o campo seja filtrado no processo de acordo com as datas selecionadas."
					}
				];

				const failedValidation = validations.find(validation => validation.condition());

				if (failedValidation) {
					Swal.fire({
						title: "Filtros da Telão Operacional",
						html: failedValidation.message,
						type: "error"
					});
					
					this.$store.commit("setLoading", { show: false });
					return null;
				}

				let dateField = null;
				let startDate = null;
				let endDate = null;
				let teamsIds = [];
				let customsBrokersIds = [];
				let importLicense = null;
				let waysOfTransport = [];
				let incoterms = [];
				let customsEnclosuresIds = [];
				let diChannels = [];
				let typesOfProcess = [];
				let priorityTypesIds = [];
				let priority = "";
				let urgent = "";
				let radarModality = '';
				let customsTeamsIds = [];

			  if (this.filter && this.filter.selectedDateField) {
				  if (this.filter.selectedDateField.attribute) {
				  	dateField = this.filter.selectedDateField.attribute;
				  }
			  }

			  if (this.filter && this.filter.selectedDateRange) {
				  if (this.filter.selectedDateRange.from) {
					  startDate = moment(this.filter.selectedDateRange.from).format("YYYY-MM-DD");
				  }

				  if (this.filter.selectedDateRange.to) {
					  endDate = moment(this.filter.selectedDateRange.to).format("YYYY-MM-DD");
				  }
			  }

			  if (this.filter && this.filter.selectedTeams && this.filter.selectedTeams.length > 0) {
				  teamsIds = this.filter.selectedTeams.map(team => team.id);
			  }

			  if (this.filter && this.filter.selectedCustomsTeams && this.filter.selectedCustomsTeams.length > 0) {
				  customsTeamsIds = this.filter.selectedCustomsTeams.map(customsTeam => customsTeam.id);
			  }

			  if (this.filter && this.filter.selectedCustomsBrokers && this.filter.selectedCustomsBrokers.length > 0) {
				  customsBrokersIds = this.filter.selectedCustomsBrokers.map(customBroker => customBroker.id);
			  }

			  if (this.filter && (this.filter.selectedImportLicenses?.id === true || this.filter.selectedImportLicenses?.id === false)) {
				  importLicense = this.filter.selectedImportLicenses.id;
			  }

			  if (this.filter && this.filter.selectedWaysOfTransport && this.filter.selectedWaysOfTransport.length > 0) {
				  waysOfTransport = this.filter.selectedWaysOfTransport.map(wayOfTransport => wayOfTransport.id);
			  }

			  if (this.filter && this.filter.selectedIncoterms && this.filter.selectedIncoterms.length > 0) {
				  incoterms = this.filter.selectedIncoterms.map(incoterm => incoterm.id);
			  }

			  if (this.filter && this.filter.selectedCustomsEnclosuresIds && this.filter.selectedCustomsEnclosuresIds.length > 0) {
				  customsEnclosuresIds = this.filter.selectedCustomsEnclosuresIds.map(customsEnclosureId => customsEnclosureId.id);
			  }

			  if (this.filter && this.filter.selectedDiChannels && this.filter.selectedDiChannels.length > 0) {
				  diChannels = this.filter.selectedDiChannels.map(diChannel => diChannel.id);
			  }

			  if (this.filter && this.filter.selectedTypesOfProcess && this.filter.selectedTypesOfProcess.length > 0) {
				  typesOfProcess = this.filter.selectedTypesOfProcess.map(typeOfProcess => typeOfProcess.id);
			  }

			  if (this.filter && this.filter.selectedPriorityTypes && this.filter.selectedPriorityTypes.length > 0) {
				  priorityTypesIds = this.filter.selectedPriorityTypes.map(priorityType => priorityType.id);
			  }

			  if (this.filter && this.filter.selectedRadarModality && this.filter.selectedRadarModality?.value) {
				  radarModality = this.filter.selectedRadarModality.value;
			  }

			  if (this.filter && this.filter.selectedPriority && this.filter.selectedPriority !== null) {
				  priority = this.filter.selectedPriority.id;
			  }


			  if (this.filter && this.filter.selectedUrgent && this.filter.selectedUrgent !== null) {
				  urgent = this.filter.selectedUrgent.id;
			  }

			  const {columns} = this.$router.currentRoute.query;
			  const response2 = await this.$store.dispatch(
				  "ProcessStore/getProcesses",
				  {
					  steps,
					  columns,
					  dateField,
					  startDate,
					  endDate,
					  teamsIds,
					  customsBrokersIds,
					  importLicense,
					  waysOfTransport,
					  incoterms,
					  customsEnclosuresIds,
					  diChannels,
					  typesOfProcess,
					  priorityTypesIds,
					  priority,
					  urgent,
					  radarModality,
					  customsTeamsIds,
				  }
			  );

			  if (!response2.success) {
				  if (
					  response.error.response.status !== undefined &&
					  response.error.response.status !== 401
				  ) {
					  Swal.fire(
						  "Telão Operacional",
						  `Houve algum problema ao tentar carregar os passos: ${response2.error}`,
						  "error"
					  );
				  }
			  }
		  }
        } else if (
          response.error.response.status !== undefined &&
          response.error.response.status !== 401
        ) {
          Swal.fire(
            "Telão Operacional",
            `Houve algum problema ao tentar carregar os passos: ${response.error}`,
            "error"
          );
        }
      } catch (err) {

		const stepIds = String(steps ?? "")
			.split(",")
			.map((id) => id.trim())
			.filter(Boolean);

		if (stepIds.includes("6") && (this.formFilterConcludedProcesses.dateField == null || this.formFilterConcludedProcesses.startDate == null)) {
			this.showCompletedProcessesDrawer = true;

			const nextStepsIds = stepIds
				.map((id) => id.trim())
				.filter((id) => id && id !== "6")
				.join(",");

			this.skipNextStepsRouteReload = true;
			this.$router.replace({
				query: {
					...this.$route.query,
					stepsIds: nextStepsIds,
				},
			});
		} else {
			console.log("err", err);
			Swal.fire(
				"Telão Operacional",
				`Houve algum problema ao tentar carregar os passos: ${err}`,
				"error"
			);
		}
      }

      this.$store.commit("setLoading", {
        show: false,
      });
    },
    sortTable() {
      this.columns = [
        ...this.columnsModel.filter((item) =>
          this.columnsMirror.includes(item)
        ),
      ];
    },
    searchObject(object, terms) {
      let shouldReturn = false;

      if (
        object !== null &&
        object !== undefined &&
        object.customer !== null &&
        object.customer !== undefined &&
        object.customer.completeName !== null &&
        object.customer.completeName !== undefined
      ) {
        delete object.customer.procedures;
      }

      for (const key in object) {
        const value = object[key];

        if (!shouldReturn && typeof value === "string") {
          shouldReturn = value.toLowerCase().search(terms.toLowerCase()) > -1;
        } else if (!shouldReturn && typeof value === "object") {
          shouldReturn = this.searchObject(value, terms);
        } else if (!shouldReturn && typeof value === "number") {
          shouldReturn =
            value
              .toString()
              .toLowerCase()
              .search(terms.toString().toLowerCase()) > -1;
        }
      }
      return shouldReturn;
    },
    thereIsDateFilter() {
      if (
        this.$route.query.from !== undefined &&
        this.$route.query.from !== null &&
        this.$route.query.to !== undefined &&
        this.$route.query.to !== null &&
        this.$route.query.selectedDateField !== undefined &&
        this.$route.query.selectedDateField !== null
      ) {
        this.filter.selectedDateRange.from = this.$route.query.from;
        this.filter.selectedDateRange.to = this.$route.query.to;
        this.filter.selectedDateField = this.$route.query.selectedDateField;

        return true;
      }
      if (
        this.filter.selectedDateRange.from &&
        this.filter.selectedDateRange.to &&
        this.filter.selectedDateField
      ) {
        return true;
      }
      return false;
    },
	async newSearchProcesses() {
		await this.loadProcesses();
	},
    searchProcesses(type, place) {
      if (
        this.processesFilterIds == null ||
        this.processesFilterIds == "" ||
        this.processesFilterIds == undefined
      ) {
        const self = this;
        const ref = this.searchTerms.trim();
        let results = [];
        const processesList =
          this.allProcesses.length > 0 ? this.allProcesses : this.processes;
        this.$store.commit("ProcessStore/SET_FILTERED_PROCESSES", []);

        if (processesList !== null) {
          if (type === "searchFilter" && ref === "") {
            this.$store.commit("ProcessStore/SET_FILTERED_PROCESSES", []);
          } else if (type === "searchFilter") {
            results = processesList.filter((item) => {
              let shouldReturn = false;
              shouldReturn = this.searchObject(item, ref);

              return shouldReturn;
            });

            if (results.length == 0) {
              Swal.fire(
                "Filtros da Telão Operacional",
                `Nenhum Processo de Importação foi encontrado com o termo <b>${ref}</b>`,
                "error"
              );
            } else {
              Swal.fire(
                "Filtros da Telão Operacional",
                `Existe(m) <b>${results.length}</b> Processo(s) de Importação com o termo <b>${ref}</b>: `,
                "success"
              );
            }
          } else {
            results = this.searchFilterComplete(type, processesList, place);
          }

          this.$store.commit("ProcessStore/SET_FILTERED_PROCESSES", results);
        }
      }
    },
    searchFilterComplete(type, results, place) {
      let data = [];
      let from = null;
      let to = null;

      if (
        !this.filter.selectedDateRange.from &&
        this.filter.selectedDateRange.to
      ) {
        Swal.fire(
          "Filtros da Telão Operacional",
          "Você precisa preencher a <b>Data Inicial</b>.",
          "error"
        );
        return null;
      }
      if (
        this.filter.selectedDateRange.from &&
        !this.filter.selectedDateRange.to
      ) {
        Swal.fire(
          "Filtros da Telão Operacional",
          "Você precisa preencher a <b>Data Final</b>.",
          "error"
        );
        return null;
      }
      if (
        this.filter.selectedDateRange.from &&
        this.filter.selectedDateRange.to &&
        !this.filter.selectedDateField
      ) {
        Swal.fire(
          "Filtros da Telão Operacional",
          "Você precisa selecionar o <b>Campo do Filtro</b> dos Filtros Diponíveis para que o campo seja filtrado no processo de acordo com as datas selecionadas.",
          "error"
        );
        return null;
      }
      if (
        this.filter.selectedDateRange.from &&
        this.filter.selectedDateRange.to &&
        this.filter.selectedDateField
      ) {
        from = moment(this.filter.selectedDateRange.from).format("Y-MM-DD");
        to = moment(this.filter.selectedDateRange.to).format("Y-MM-DD");
      }

      let filterDone = false;
      data = results.filter((item) => {
        let returnDate = true;
        let returnTeam = true;
        let returnCustomsBrokers = true;

        if (
          from !== null &&
          to !== null &&
          this.filter.selectedDateField !== null
        ) {
          filterDone = true;
          if (
            item[this.filter.selectedDateField.attribute] !== null &&
            item[this.filter.selectedDateField.attribute] !== "" &&
            item[this.filter.selectedDateField.attribute]
          ) {
            const date = moment(
              item[this.filter.selectedDateField.attribute]
            ).format("Y-MM-DD");
            if (date >= from && date <= to) returnDate = true;
            else returnDate = false;
          } else {
            returnDate = false;
          }
        }

        if (
          this.filter !== null &&
          this.filter.selectedTeams !== null &&
          this.filter.selectedTeams !== undefined &&
          this.filter.selectedTeams.length > 0
        ) {
          filterDone = true;

          if (item.customer !== null && item.customer !== undefined) {
            returnTeam =
              this.filter.selectedTeams.filter(
                (team) =>
                  team.id === item.customerTeamId ||
                  team.id === item.customerTeamOrderId ||
                  team.id === item.customerTeamAdvisoryId
              ).length > 0;
          }
        }

        if (
          this.filter !== null &&
          this.filter.selectedCustomsBrokers !== null &&
          this.filter.selectedCustomsBrokers !== undefined &&
          this.filter.selectedCustomsBrokers.length > 0
        ) {
          filterDone = true;
          returnCustomsBrokers =
            this.filter.selectedCustomsBrokers.filter(
              (customBroker) =>
                item.customBroker !== null &&
                customBroker.completeName === item.customBroker
            ).length > 0;
        }

        return returnDate && returnTeam && returnCustomsBrokers;
      });

      if (place === undefined && filterDone) {
        if (data.length == 0) {
          Swal.fire(
            "Filtros da Telão Operacional",
            "Nenhum Processo de Importação foi encontrado.",
            "error"
          );
        } else {
          Swal.fire(
            "Filtros da Telão Operacional",
            `Processo(s) de Importação encontrado(s): <b>${data.length}</b>`,
            "success"
          );
        }
      }

      return data;
    },
    clearSearchFilterComplete(type) {
      this.$store.commit("ProcessStore/SET_FILTERED_PROCESSES", []);

      if (type === "selectedDateRange") {
        this.filter.selectedDateRange.from = "";
        this.filter.selectedDateRange.to = "";
        this.filter.selectedDateField = "";
      }

      if (type === "filterSelect") {
		this.filter.selectedDateRange.from = "";
        this.filter.selectedDateRange.to = "";
        this.filter.selectedDateField = "";
		this.filter.selectedCustomsBrokers = [];
		this.filter.selectedImportLicenses = null;
		this.filter.selectedWaysOfTransport = [];
		this.filter.selectedIncoterms = [];
		this.filter.selectedCustomsEnclosuresIds = [];
		this.filter.selectedDiChannels = [];
		this.filter.selectedTypesOfProcess = [];
		this.filter.selectedPriorityTypes = [];
		this.filter.selectedPriority = null;
		this.filter.selectedUrgent = null;
		this.filter.selectedRadarModality = null;
		this.newSearchProcesses();
      }
    },
    clearSearch() {
		this.searchTerms = "";
		this.$store.commit("ProcessStore/SET_FILTERED_PROCESSES", []);
		
		if (this.$route.query.selectedTeams) {
			this.selectedTeams = this.$route.query.selectedTeams.split(",").map((item) => parseInt(item));
		} else if (this.$store.state.credentials.data.person.team !== null) {
			this.filter.selectedTeams = [];
			this.filter.selectedTeams.push(this.$store.state.credentials.data.person.team);
			this.searchProcesses("searchFilterComplete");
		}

		if (this.$route.query.selectedCustomsTeams) {
			this.filter.selectedCustomsTeams = this.$route.query.selectedCustomsTeams.split(",").map((item) => parseInt(item));
		} else if (this.$store.state.credentials.data.person.customsTeams !== null) {
			this.filter.selectedCustomsTeams = [];
			const credTeams = this.$store.state.credentials.data.person.customsTeams;
			this.filter.selectedCustomsTeams.push(
				...(Array.isArray(credTeams) ? credTeams : [credTeams])
			);
			this.syncSelectedCustomsTeamsWithOptions();
			this.searchProcesses("searchFilterComplete");
		}
    },
    async findProcessByIdentificationSearch() {
      if (this.findProcessByIdentification == "") {
        Swal.fire(
          this.mainTitle,
          "A referência não pode ser nula ou vazia",
          "error"
        );
        return;
      }

      if (this.process) {
        this.socket.send(
          JSON.stringify({
            action: config.env.WEBSOCKET.actions.CLOSE_PROC,
            data: {
              [this.process.id]: this.$store.state.credentials.data.person.name,
            },
          })
        );
      }

      this.$store.commit("ProcessStore/HIDE_PROCESS");

      const response = await this.$store.dispatch(
        "ProcessStore/findProcessByIdentification",
        this.findProcessByIdentification
      );

      if (!response.success) {
        Swal.fire(
          this.mainTitle,
          response.error.response.data.message,
          "error"
        );
        return;
      }

      if (!this.openedProcesses[response.data.id]) {
        this.socket.send(
          JSON.stringify({
            action: config.env.WEBSOCKET.actions.OPEN_PROC,
            data: {
              [response.data.id]:
              this.$store.state.credentials.data.person.name,
            },
          })
        );
      }
    },
    findProcessByIdentificationClearSearch() {
      this.findProcessByIdentification = "";
      this.$store.commit("ProcessStore/SET_FILTERED_PROCESSES", []);
    },
	closeNewProcessModal() {
		this.formErrors = [];
		this.newProcessPayload = {
			customerRef: null,
			customer: null,
			typeOfProcess: null,
		};
		this.newProcessModal = false;
	},
    async newProcess() {
		this.formErrors = [];
		await this.findActiveCustomers();
		this.newProcessPayload = {
			customerRef: null,
			customer: null,
			typeOfProcess: null,
		};
		this.newProcessModal = true;
    },
	async saveNewProcess() {
		try {
			this.$store.commit("setLoading", {
				show: true,
				label: "Novo Processo",
				description: "Salvando o processo...",
			});

			this.formErrors = [];

			// Gerar identificação
			const identification = await this.generateProcessIdentification();
			if (!identification) {
				Swal.fire(
					"Erro",
					"Não foi possível gerar uma Referência Interna para este processo.",
					"error"
				);
				return;
			}
	
			let data = {
				id: null,
				customerRef: this.newProcessPayload?.customerRef ?? "",
				customerId: this.newProcessPayload?.customer?.attribute ?? "",
				typeOfProcess: "CONTA_E_ORDEM",
				step: config.env.API_DEFAULT.host + "/processSteps/7",
				status: null,
				statusDateOfLastModify: null,
				statusCustomBrokerDateOfLastModify: null,
				operationStatusDateOfLastModify: null,
				identification: identification,
				invoiceTotal: 0,
				cifValue: 0,
				account: config.env.API_DEFAULT.host + "/accounts/1"
			};

			// Validar schema
			let schema = this.schema();
			await schema.validate(data, { abortEarly: false });
			let customerRef = await Axios.get(`${config.env.API_DEFAULT.host}/newImportProcess/check-customer-ref?customerRef=${data.customerRef}&customerId=${data.customerId}`);

			// Verificar referência duplicada
			const hasDuplicate = await this.checkForDuplicateReference(data);
			if (hasDuplicate) {
				return; // O usuário já foi notificado
			}	

			const response = await this.$store.dispatch( "ProcessStore/postImportProcess", { model: data});

			if (response?.process) {
            	this.newProcessModal = false;
				this.newProcessPayload = {
					customerRef: null,
					customer: null,
					typeOfProcess: null,
				};
			} else {
				throw new Error("Erro ao criar o processo");
			}
			
		} catch (e) {
			if (e.name && e.name === "ValidationError") {
				this.formErrors = e.inner;
			} else {
				let message = "Erro ao salvar!";
				if (e?.response?.data?.message) {
					message = e.response.data.message;
				} else if (e.message) {
					message = e.message;
				}
				Swal.fire({
					title: "Novo Processo de Importação",
					text: message,
					type: "error",
				});
			}
		} finally {
			this.$store.commit("setLoading", {
				show: false,
			});
		}
	},
	async generateProcessIdentification() {
		try {
			const response = await Axios.get(
				`${config.env.API_DEFAULT.host}/process/import/generateNewIdentification`
			);
			return response?.data?.data?.next;
		} catch (error) {
			return null;
		}
	},
	async checkForDuplicateReference(data) {
		try {
			const response = await Axios.get(
				`${config.env.API_DEFAULT.host}/newImportProcess/check-customer-ref`,
				{
					params: {
						customerRef: data.customerRef,
						customerId: data.customerId
					}
				}
			);

			if (response?.data?.data?.exists && response.data.data.processes.length > 0) {
				const processes = response.data.data.processes;
				let html = `<div class="text-left pl-4 pr-4 pt-4">
					<p>Ref. Pedido/Cliente <span class="tx-bold">${data.customerRef}</span> já foi utilizada anteriormente para este cliente. Veja os processos abaixo:</p>
					<ul class="list-group">`;

				processes.forEach(process => {
					html += `<li class="list-group-item flex ai-c jc-sb fgap2">
						<p class="mg-b-0">${ProcessService.getTypeOfProcessReference(process)}</p>
						<a 
							href="/operational/imp/desk?showProcess=true&identification=${process.identification}" 
							rel="nofollow noopener noreferrer" 
							class="crm-button small" 
							target="_blank"
						>Ver Processo</a>
					</li>`;
				});

				html += `</ul>
					<p class="mg-t-3" style="font-size: 0.9rem;">
						Obs.: ao clicar em "Ver Processo", o processo será aberto em uma nova aba.
					</p>
				</div>`;

				const result = await Swal.fire({
					title: "Novo Processo de Importação",
					html: html,
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: "Criar assim mesmo",
					cancelButtonText: "Cancelar",
				});

				return !result.value;
			}

			return false;
		} catch (error) {
			console.error("Erro ao verificar referência duplicada:", error);
			return false;
		}
	},
    getDeskStateKey(state) {
      if (state && state._links && state._links.self && state._links.self.href) {
        return state._links.self.href;
      }
      return state.id;
    },
    isActiveDeskState(state) {
      return this.activeDeskStateKey === this.getDeskStateKey(state);
    },
    clearActiveDeskState() {
      this.activeDeskStateKey = null;
    },
    handleSaveDeskState() {
      if (!this.activeDeskState) {
        this.openCreateDeskStateModal();
        return;
      }

      Swal.fire({
        title: "Salvar perfil",
        html: `Perfil ativo: <strong>${this.activeDeskState.name}</strong><br><br>Deseja salvar no perfil atual ou criar um novo?`,
        type: "question",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Salvar no perfil atual",
        cancelButtonText: "Criar novo perfil",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.updateActiveDeskState();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.openCreateDeskStateModal();
        }
      });
    },
    openCreateDeskStateModal() {
      this.modal.deskState.show = true;
    },
    async updateActiveDeskState() {
      const state = this.activeDeskState;
      if (!state) return;

      try {
        this.$store.commit("setLoading", {
          show: true,
          label: "Perfis",
          description: `Atualizando o perfil ${state.name}...`,
        });

        const payload = {
          name: state.name,
          processType: "IMPORT",
          context: "DESK",
          steps: JSON.stringify(this.statusFilters),
          columns: JSON.stringify(this.columnsMirror),
          filter: JSON.stringify(this.filter),
        };

        await Axios.put(
          `${config.env.API_DEFAULT.host}/desk/states/${state.id}`,
          payload
        );

        this.loadDeskStates();

        Swal.fire(
          "Perfis",
          `O perfil <strong>${state.name}</strong> foi atualizado com sucesso!`,
          "success"
        );
      } catch (error) {
        Swal.fire("Perfis", error.message, "error");
      } finally {
        this.$store.commit("setLoading", {
          show: false,
        });
      }
    },
    selectDeskStates(state) {
      this.changeToDefaultColumns = false;
      this.activeDeskStateKey = this.getDeskStateKey(state);
      if (state.steps !== null) {
        this.statusFilters = state.steps.map((item) => parseInt(item));
        this.loadProcesses(state.steps.toString());
      }

      if (state.columns !== null) {
        this.columns = state.columns;
        this.columnsMirror = state.columns;
      }

      if (state.filter !== null) {
        this.filter = state.filter;

        if (
          this.filter.selectedDateRange.from !== null &&
          this.filter.selectedDateRange.to !== null &&
          this.filter.selectedDateField !== null
        ) {
          this.searchProcesses("searchFilterComplete");
        } else {
          this.searchProcesses();
        }
      }
    },
    onChangeColumns(newVal) {
      this.columns = [...newVal];
      this.columnsMirror = [...newVal];
    },
    deleteDeskStates(state) {
      Swal.fire({
        title: "Você tem certeza?",
        html: `Se você excluir o estado <strong>${state.name}</strong>, não será possível recuperá-lo para uso posterior.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((willContinue) => {
        if (willContinue.value) {
          this.$store.commit("setLoading", {
            show: true,
            label: "Estado da Mesa",
            description: `Excluindo o estado ${state.name}...`,
          });

          Axios.delete(
            `${config.env.API_DEFAULT.host}/desk/states/${state.id}`
          )
            .then((response) => {
              this.$store.commit("setLoading", {
                show: false,
              });
              if (this.isActiveDeskState(state)) {
                this.activeDeskStateKey = null;
              }
              Swal.fire(
                "Estado da Mesa",
                `O estado da mesa <strong>${state.name}</strong> foi excluído com sucesso!`,
                "success"
              );
              this.loadDeskStates();
            })
            .catch((error) => {
              this.$store.commit("setLoading", {
                show: false,
              });
              if (error.response.status === 409) {
                Swal.fire(
                  "Estado da Mesa",
                  `Não foi possível excluir a ${this.modelTitle}, porque ela já está em uso por algum lançamento financeiro.`,
                  "error"
                );
              } else {
                Swal.fire("Estado da Mesa", error.message, "error");
              }
            });
        }
      });
    },
    loadDeskStates() {
      this.$store.commit("setLoading", {
        show: true,
        label: "Estado da Mesa",
        description: "Carregandos os estados disponíveis no seu perfil...",
      });

      Axios.get(
        `${config.env.API_DEFAULT.host}/desk/states?context=DESK`
      )
        .then((response) => {
          this.deskStates = response.data.data || [];
          this.$store.commit("setLoading", {
            show: false,
          });
        })
        .catch((error) => {
          this.$store.commit("setLoading", {
            show: false,
          });
          Swal.fire(
            "Perfis",
            `Houve algum problema ao tentar carregar os Perfis de Telão Operacional cadastrados pelo usuário: ${error.response}`,
            "error"
          );
        });
    },
    async findImportProcessesByKeyword(newTab) {
      if (!this.keyword) {
        Swal.fire(
          "Pesquisa Geral",
          "Você precisa digitar algo para ser pesquisado.",
          "error"
        );
        return false;
      }

      const response = await this.$store.dispatch(
        "ProcessStore/findImportProcessesByKeyword",
        this.keyword
      );
      if (response !== undefined && response !== null && response.success) {
        this.$store.commit("ProcessStore/HIDE_PROCESS");

        if (response.data.data.length > 1) {
          this.$store.commit("ProcessStore/SET_PROCESSES", response.data.data);

          Swal.fire(
            "Pequisa Geral",
            `Foram encontrados ${response.data.data.length} processos nesta pesquisa.`,
            "success"
          );
          this.$router.push("/operational/imp/desk?showProcess=false");

          // if (newTab) {
          //     var routeData = this.$router.resolve({
          //         name: 'operational-imp-desk',
          //         query: {
          //             showProcess: "false",
          //             stepsIds: ""
          //         }
          //     });
          // } else {
          //     this.$router.push("/operational/imp/desk?stepsIds=&showProcess=true");
          //     this.statusFilters = [];
          // }
        } else if (response.data.data.length === 1) {
          if (
            this.openedProcesses[response.data.data[0].id] &&
            this.openedProcesses[response.data.data[0].id].user !=
            this.credentials.data.person.name
          ) {
            this.$store.commit("ProcessStore/SET_NOCLICK", true);
          }
          this.$store.commit("ProcessStore/SET_ACTIVE", response.data.data[0]);
          this.$router.push("/operational/imp/desk?showProcess=true");
        } else {
          Swal.fire(
            "Pesquisa Geral",
            `Nenhum resultado foi encontrado com o termo <strong>${this.keyword}</strong>.`,
            "error"
          );
        }
      } else Swal.fire("Pesquisa Geral", response.message, "error");
    },
    findImportProcessesByKeywordClearSearch() {
      this.keyword = "";
      this.$store.commit("ProcessStore/SET_FILTERED_PROCESSES", []);
    },
  },

  async mounted() {
    if (!this.$store.state.ProcessStore.socket) {
		this.connectWs();
	}

    this.$store.commit("defaultLayoutDisabled");
    this.$store.commit("ProcessStore/SET_FILTERED_PROCESSES", []);

    this.$store.commit("setLoading", {
      show: true,
      label: "Aguarde...",
      description: "Preparando os processos para a operação...",
    });

    if (
      this.$router.currentRoute.query.filteredByReport == null &&
      !this.$router.currentRoute.query.filteredByReport
    ) {
      if (
        this.stateSteps.length > 0 &&
        this.stateColumns != null &&
        this.stateColumns != ""
      ) {
        this.$router.replace({
          query: {
            stepsIds: this.stateSteps.join(","),
            columns: this.stateColumns,
          },
        });
      }

      if (this.$route.query.processesIds && this.$route.query.stepsIds) {
        await this.loadProcesses(this.$route.query.stepsIds);
        this.setProcessesFilterIds({
          processesIds: this.$route.query.processesIds,
        });
      } else if (this.stateSteps.length > 0) {
        this.statusFilters = this.stateSteps;
        this.loadProcesses(this.stateSteps);
      } else if (this.$route.query.stepsIds) {
        this.statusFilters = this.$route.query.stepsIds
          .split(",")
          .map((item) => parseInt(item));
        this.loadProcesses(this.statusFilters);
      } else this.loadProcesses("");

      if (this.$route.query.columns) {
        this.columns = this.$route.query.columns.split(",");
        this.columnsMirror = this.$route.query.columns.split(",");
      }

      if (this.$route.query.showProcess === true) {
        this.showProcess = true;
        // } else {
        //     this.$store.commit('ProcessStore/SET_PROCESSES', []);
      }

      this.$store.commit("setLoading", {
        show: false,
      });

      Axios.get(`${config.env.API_DEFAULT.host}/teams`).then((response) => {
        this.teams = response.data._embedded.teams;
      });

	  Axios.get(`${config.env.API_DEFAULT.host}/customs-teams`).then((response) => {
		this.customsTeams = response.data.data;
		this.syncSelectedCustomsTeamsWithOptions();
	  });

	  Axios.get(`${config.env.API_DEFAULT.host}/customsEnclosures/search/findAllCustomsEnclosureByDescription?description=`).then((response) => {
		this.listCustomsEnclosures = response.data._embedded.customsEnclosures.map((item) => ({id: item.id, name: item.code + ' | ' + item.alias}));
	  });

      Axios.get(
        // `${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomBroker?isCustomBroker=true`
        `${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomBrokerIsTrue`
      ).then((response) => {
        this.customsBrokers = response.data._embedded.companies;
      });

	  Axios.get(
        `${config.env.API_DEFAULT.host}//newImportProcess/priority-types`
      ).then((response) => {
        this.listPriorityTypes = response.data.data.map((item) => ({id: item.id, name: item.description}));
      });

      this.loadDeskStates();
      EventBus.$on("operational.imp.Desk.loadDeskStates", () => {
        this.loadDeskStates();
      });

      setTimeout(() => {
        if (this.$route.query.selectedTeams) {
          this.selectedTeams = this.$route.query.selectedTeams
            .split(",")
            .map((item) => parseInt(item));
        } else if (this.$store.state.credentials.data.person.team !== null) {
          this.filter.selectedTeams.push(
            this.$store.state.credentials.data.person.team
          );
          // this.searchProcesses("searchFilter", "mounted");
			// this.newSearchProcesses();
        }

		if (this.$route.query?.selectedCustomsTeams) {
			this.filter.selectedCustomsTeams = this.$route.query.selectedCustomsTeams.split(",").map((item) => parseInt(item));
		} else if (this.$store.state.credentials?.data?.person?.customsTeams) {
			const credTeams = this.$store.state.credentials.data.person.customsTeams;
			this.filter.selectedCustomsTeams.push(
				...(Array.isArray(credTeams) ? credTeams : [credTeams])
			);
		}
		this.syncSelectedCustomsTeamsWithOptions();
      }, 2000);

      this.findActiveCustomers();

      if (this.$route.query.identification) {
        await this.$store.dispatch(
          "ProcessStore/findProcessByIdentification",
          this.$route.query.identification
        );
      }
    }
  },
  watch: {
    async statusFilters(newVal) {

      this.$store.commit("ProcessStore/SET_STATE_STEPS", newVal);

      if (
        this.$route.query.columns != "" &&
        this.$route.query.columns != null
      ) {
        this.$store.commit(
          "ProcessStore/SET_STATE_COLUMNS",
          this.$route.query.columns
        );
      }

      const stateSteps = await this.getStateSteps();

      if (stateSteps.length > 0) {
        if (stateSteps.length === 1 && this.changeToDefaultColumns) {
          this.columns = this.stepsColumns[newVal[0]];
          this.columnsMirror = this.stepsColumns[newVal[0]];
        }

        this.changeToDefaultColumns = true; // para setar as colunas default

        const steps = stateSteps.reduce(
          (sum, item) => sum + (sum == "" ? "" : ",") + item,
          ""
        );

        const query = {
          selectedTeams: this.$route.query.selectedTeams,
          stepsIds: steps,
          columns: this.$route.query.columns,
          showProcess: this.$route.query.showProcess,
          selectedCustomsTeams: this.$route.query.selectedCustomsTeams,
        };

        this.$router.push({
          name: "operational-imp-desk",
          query,
        });

        if (this.thereIsDateFilter()) {
          setTimeout(() => {
            this.searchProcesses("searchFilterComplete");
          }, 1000);
        }
      } else {
        this.$store.commit("ProcessStore/SET_PROCESSES", []);

        this.$router.push({
          name: "operational-imp-desk",
          query: {
            selectedTeams: this.$route.query.selectedTeams,
            stepsIds: "",
            columns: this.$route.query.columns,
            showProcess: this.$route.query.showProcess,
			selectedCustomsTeams: this.$route.query.selectedCustomsTeams,
          },
        });
      }
    },
    columns(newVal, oldVal) {
      if (
        this.processesFilterIds == null ||
        this.processesFilterIds == "" ||
        this.processesFilterIds == undefined
      ) {
        if (newVal.length > 0) {
          const columns = newVal.reduce(
            (sum, item) => sum + (sum == "" ? "" : ",") + item,
            ""
          );

          if (newVal.length !== oldVal.length) {
            this.$router.push({
              name: "operational-imp-desk",
              query: {
                selectedTeams: this.$route.query.selectedTeams,
                stepsIds: this.$route.query.stepsIds,
                processesIds: this.$route.query.processesIds,
                columns,
                showProcess: this.$route.query.showProcess,
				selectedCustomsTeams: this.$route.query.selectedCustomsTeams,
              },
            });
          }
        } else {
          this.$router.push({
            name: "operational-imp-desk",
            query: {
              selectedTeams: this.$route.query.selectedTeams,
              stepsIds: this.$route.query.stepsIds,
              columns:
                "identification,account,step,customer,exporter,invoice,customerRef,customsEnclosure,billOfLading,datesETA,datesETD, datesDepartureDate, datesArrivalDate",
              showProcess: this.$route.query.showProcess,
				selectedCustomsTeams: this.$route.query.selectedCustomsTeams,
            },
          });
        }
      }
    },
    $route(newVal, oldVal) {
      if (newVal.query.stepsIds !== oldVal.query.stepsIds) {
        if (this.skipNextStepsRouteReload) {
          this.skipNextStepsRouteReload = false;
          return;
        }

        this.loadProcesses(newVal.query.stepsIds);
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    this.statusFilters = [];
    this.$store.commit("ProcessStore/SET_STATE_STEPS", []);
    this.$store.commit("ProcessStore/SET_PROCESSES", []);
    next();
  },
};
</script>

<style scoped>
.search-item {
  display: flex;
  align-items: center;
}

.search-item label {
  border-bottom: 1px solid rgba(255, 255, 255, 0.33);
  padding: 0 6px;
  margin: 0;
}

.search-item input {
  background: none;
  border: none;
  color: #fff;
  outline: none;
  margin: 0;
}

.search-item input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.v-select {
  margin-top: 0px !important;
  padding: 0px !important;
}

.toggleHeader-enter-active {
  transition: transform 0.5s, opacity 0.5s;
}

.toggleHeader-leave-active {
  transition: transform 0.2s, opacity 0.2s;
}

.toggleHeader-enter,
.toggleHeader-leave-to {
  transform: translateY(-152px);
  opacity: 0;
}

.status-filters.nav-pills .nav-item {
  cursor: pointer;
  margin: 0;
  padding: 0;
}

.status-filters.nav-pills .nav-item input[type="checkbox"] {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.status-filters.nav-pills .nav-item .nav-link {
  border-radius: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-right: none;
}

.status-filters.nav-pills .nav-item .nav-link:last-child .nav-link {
  border-right: 1px solid #ddd;
}

.status-filters.nav-pills .nav-item:last-child .nav-link {
  border: 1px solid #ddd; 
}

.status-filters.nav-pills .nav-item .nav-link:last-child .nav-link.active {
  border-right: 1px solid #106dc4;
}

.checkbox span {
  display: block;
  border: 1px solid #ddd;
  padding: 6px;
  border-radius: 2px;
}

.checkbox input[type="checkbox"] {
  width: 1px;
  height: 1px;
  top: 0;
  left: 0;
  opacity: 0;
  display: none;
}

.checkbox input[type="checkbox"]:checked + span {
  border-color: #106dc4;
  color: #106dc4;
  font-weight: 500;
  background-color: rgba(16, 109, 196, 0.1);
}

.checkbox {
  display: block;
  position: relative;
  margin: 0 0 3px 0;
}

.mx-datepicker {
  max-width: 120px;
}

.table-area {
  overflow: auto;
  height: calc(100vh - 54px - 57px - 30px);
  position: relative;
}

.table-area.showHeader {
  height: calc(100vh - 54px - 57px - 30px - 152px);
}

.table-area.showSearch {
  height: calc(100vh - 54px - 57px - 30px - 62px);
}

.table-area.showHeader.showSearch {
  height: calc(100vh - 54px - 57px - 30px - 62px - 152px);
}

.btn-icon.btn-sm > div {
  width: 24px;
  height: 24px;
}

.list-group-item .user-name-address {
  cursor: pointer;
  width: 100%;
}

.consulta-ces-table-wrap {
  max-height: 55vh;
  overflow: auto;
}

.consulta-ces-table-wrap .ws-nw {
  white-space: nowrap;
}

.menu-desk  {
  background: var(--primary-bg-header);
}

.imput-process-by-identification {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* Para Chrome e Safari */
@media screen and (-webkit-min-device-pixel-ratio:0) {
  .imput-process-by-identification::-webkit-inner-spin-button,
  .imput-process-by-identification::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

/* Para Firefox */
@-moz-document url-prefix() {
  .imput-process-by-identification::-moz-inner-spin-button,
  .imput-process-by-identification::-moz-outer-spin-button {
    -moz-appearance: none;
    margin: 0;
  }
}

.input-modify {
	width: auto;
    border: 1px solid #e2e2e2;
    border-radius: 8px;
    padding: 0px 10px 0px 10px;
	min-height: 30px;
}

.input-modify.danger {
	border-color: var(--danger);
}

.input-modify__input {
	width: 100%;
    border: 1px solid #e2e2e2;
    border-radius: 8px;
    padding: 0px 10px 0px 10px;
	min-height: 43px;
}

.field-error {
  padding: 0.25rem;
  color: var(--danger);
}

.filter-button .badge {
    position: relative;
    padding: 7px 10px;
    border-radius: 20%;
    background: #dc3545;
    color: white;
}

.list-group-user .list-group-item:not(.profile-item-active) .user-name-address:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.list-group-user .list-group-item.profile-item-active {
  background-color: rgba(16, 109, 196, 0.08);
  border-left: 3px solid #106dc4;
}

.list-group-user .list-group-item.profile-item-active .user-name-address p {
  color: #106dc4;
  font-weight: 600;
}

.list-group-user .list-group-item.profile-item-active .user-name-address span {
  color: #6c757d;
}

</style>

<style>
.input-modify .multiselect__select {
	top: 3px !important;
}

.input-modify .multiselect__tags {
	min-height: 40px !important;
}

.input-modify .multiselect__content-wrapper {
	width: 97% !important;
}

@media (max-height: 1150px) {
	.top-down-filter .dropdown-menu {
		top: auto !important;
		bottom: 100% !important;
		margin-bottom: 15px !important;
		border-radius: 4px 4px 0 0;
	}
}

.filter-date .mx-datepicker,
.filter-date .mx-input-wrapper {
	width: 100% !important;
	max-width: 250px !important;
}

.widthModify {
	width: 35vw !important;
}

/* Mesa — dropdown Ações */
.desk-header-actions__menu {
	min-width: 300px;
	max-width: 360px;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
	border: 1px solid rgba(0, 0, 0, 0.06);
}

.desk-header-actions__toggle .fa-angle-down {
	vertical-align: middle;
}

.desk-header-actions__item {
	cursor: pointer;
	border-left: 0 !important;
	border-right: 0 !important;
	transition: background-color 0.15s ease;
}

.desk-header-actions__item:hover {
	background-color: #f4f7fb;
}

.desk-header-actions__item:first-of-type {
	border-top: 0 !important;
}

/* Modal Consulta CEs incluídos */
.v-modal-container.consulta-ces-vmodal.consulta-ces-vmodal--result {
	max-width: min(96vw, 1720px) !important;
}

.v-modal-container.consulta-ces-vmodal {
	max-height: 92vh !important;
}

.consulta-ces-process-ref-row {
	flex-wrap: wrap;
}

.consulta-ces-badge-ce-atual {
	font-weight: 600;
	vertical-align: middle;
}

.v-modal-container.consulta-ces-vmodal.consulta-ces-vmodal--form {
	max-height: 78vh !important;
}

.v-modal-container.consulta-ces-vmodal .v-modal-footer {
	padding: 18px 28px 22px !important;
}

.v-modal-container.consulta-ces-vmodal.consulta-ces-vmodal--form .v-modal-footer {
	padding: 14px 20px 16px !important;
}

.v-modal-content.consulta-ces-vmodal.has-padding {
	padding: 24px 28px 28px !important;
}

.v-modal-content.consulta-ces-vmodal.consulta-ces-vmodal--form.has-padding {
	padding: 16px 20px 18px !important;
}

.consulta-ces-modal-step1 {
	padding-bottom: 4px;
}

.consulta-ces-modal-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px 24px;
	align-items: start;
}

@media (max-width: 991px) {
	.consulta-ces-modal-grid {
		grid-template-columns: 1fr;
	}
}

.consulta-ces-field__error {
	font-size: 0.8125rem;
	color: #dc3545;
}

.consulta-ces-field--disabled {
	opacity: 0.75;
	pointer-events: none;
}

/* Label flutuante igual ao VInput (campo data ao lado) — ver VInput.vue .input-control */
.consulta-ces-modal-step1 .consulta-ces-input-control.input-control {
	position: relative;
	width: 100%;
}

.consulta-ces-modal-step1 .consulta-ces-input-control.input-control label.no-events {
	pointer-events: none;
	margin-bottom: 0 !important;
	font-size: 1rem;
	position: absolute;
	top: 10px;
	left: 15px;
	transition: all 0.2s ease-in-out 0s;
	background-color: #fff;
	z-index: 5;
	padding: 1px 4px;
	/* Mesmo tom dos rótulos/descrições CRM e do texto do date-picker */
	color: #868ba1;
}

.consulta-ces-modal-step1 .consulta-ces-input-control.input-control.active label.no-events {
	display: block;
	top: -8px;
	font-size: 0.7rem;
	max-width: calc(100% - 24px);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	border-radius: 8px;
	color: #868ba1;
}

.consulta-ces-modal-step1 .consulta-ces-input-control label.no-events .tx-danger {
	color: #dc3545 !important;
}

/* Mesmo padrão CRM: wrapper com borda; input interno do vue-select sem “segunda caixa” */
.consulta-ces-modal-step1 .consulta-ces-input-control .select-wrapper-int .v-select input[type="search"].form-control {
	height: 45px !important;
	line-height: 45px !important;
	margin-top: 0 !important;
	border: none !important;
	box-shadow: none !important;
	border-radius: 0 !important;
	background: transparent !important;
	padding-left: 0 !important;
	color: #868ba1 !important;
}

.consulta-ces-modal-step1 .consulta-ces-input-control .select-wrapper-int .v-select input[type="search"].form-control::placeholder {
	color: #a5a9b5 !important;
	opacity: 1;
}

.consulta-ces-modal-step1 .consulta-ces-input-control .select-wrapper-int .dropdown-toggle {
	min-height: 45px !important;
	display: flex !important;
	align-items: center !important;
}

.consulta-ces-modal-step1 .consulta-ces-vselect__selected,
.consulta-ces-modal-step1 .consulta-ces-input-control .select-wrapper-int .v-select .consulta-ces-vselect__selected {
	color: #868ba1 !important;
	font-weight: 400 !important;
	line-height: 1.3 !important;
	white-space: normal !important;
}

.consulta-ces-modal-step1 .consulta-ces-input-control .select-wrapper-int .v-select .consulta-ces-vselect__selected small {
	font-weight: 400 !important;
	color: #a5a9b5 !important;
}

.consulta-ces-modal-footer {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 14px 20px;
	width: 100%;
}

.consulta-ces-modal-footer__left,
.consulta-ces-modal-footer__right {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 12px;
}

.consulta-ces-result-wrap {
	padding-bottom: 8px;
}

.consulta-ces-result-panel {
	border: 1px solid #e2e2e2;
	background: #f8f9fa;
	overflow: hidden;
}

.consulta-ces-result-panel__toolbar {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px 20px;
	padding: 12px 16px;
}

.consulta-ces-result-panel__identity {
	flex: 1 1 260px;
	min-width: 0;
}

.consulta-ces-result-panel__title {
	margin: 0 0 6px 0;
	font-size: 15px;
	font-weight: 600;
	line-height: 1.3;
	color: #343a40;
}

.consulta-ces-result-panel__meta-line {
	margin: 0;
	font-size: 12px;
	line-height: 1.45;
	color: #868ba1;
}

.consulta-ces-result-panel__meta-item strong {
	color: #5c6573;
	font-weight: 600;
	margin-right: 4px;
}

.consulta-ces-result-panel__dot {
	margin: 0 6px;
	color: #c5ccd4;
}

.consulta-ces-result-panel__counts-line {
	margin: 6px 0 0 0;
	font-size: 12px;
	line-height: 1.45;
	color: #343a40;
}

.consulta-ces-result-panel__count-pill strong {
	font-weight: 700;
	color: #0866c6;
	margin-right: 4px;
}

.consulta-ces-result-panel__search {
	flex: 0 1 320px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px 10px;
	justify-content: flex-end;
	min-width: 200px;
}

.consulta-ces-result-panel__search-field {
	display: flex;
	align-items: center;
	flex: 1 1 200px;
	max-width: 100%;
	min-height: 36px;
	padding: 0 10px 0 12px;
	border: 1px solid #e2e2e2;
	border-radius: 8px;
	background: #fff;
	box-sizing: border-box;
}

.consulta-ces-result-panel__search-field:focus-within {
	border-color: #b8c2cc;
	box-shadow: 0 0 0 1px rgba(8, 102, 198, 0.12);
}

.consulta-ces-result-panel__search-label {
	display: flex;
	align-items: center;
	gap: 6px;
	margin: 0 8px 0 0;
	font-size: 12px;
	font-weight: 600;
	color: #868ba1;
	white-space: nowrap;
	flex-shrink: 0;
}

.consulta-ces-result-panel__search-label .fa-search {
	font-size: 13px;
	color: #a5a9b5;
}

.consulta-ces-result-panel__search-input {
	flex: 1 1 auto;
	min-width: 0;
	height: 34px;
	border: none !important;
	box-shadow: none !important;
	padding: 0 4px 0 0 !important;
	font-size: 13px;
	color: #343a40;
	background: transparent !important;
}

.consulta-ces-result-panel__search-input:focus {
	outline: none;
}

.consulta-ces-result-panel__search-input::placeholder {
	color: #a5a9b5;
}

.consulta-ces-result-panel__filter-badge {
	color: #5c6573;
	font-weight: 600;
	white-space: nowrap;
}

.consulta-ces-result-panel__hint {
	padding: 8px 16px 10px;
	margin: 0;
	border-top: 1px solid #e9ecef;
	background: #fff;
	line-height: 1.45;
}

.consulta-ces-result-panel__hint strong {
	color: #5c6573;
	font-weight: 600;
}

@media (max-width: 767px) {
	.consulta-ces-result-panel__search {
		flex: 1 1 100%;
		justify-content: flex-start;
	}

	.consulta-ces-result-panel__search-field {
		flex: 1 1 100%;
		max-width: none;
	}
}

.consulta-ces-table__thead th {
	background: #eef2f7;
	color: #2b3d51;
	font-weight: 600;
	font-size: 11px;
	text-transform: uppercase;
	letter-spacing: 0.02em;
	border-bottom: 1px solid #e2e2e2;
	vertical-align: middle;
}

.consulta-ces-table tbody td {
	vertical-align: middle;
}

.consulta-ces-table th.consulta-ces-th-processos,
.consulta-ces-table td.consulta-ces-td-processos {
	border-left: 3px solid #c5d0dc !important;
	background-color: #f4f7fb !important;
}

.consulta-ces-table th.consulta-ces-th-acao,
.consulta-ces-table td.consulta-ces-td-acao {
	background-color: #fff !important;
	border-left: 1px solid #e2e2e2 !important;
}

.consulta-ces-process-ref {
	display: block;
	padding: 5px 8px 5px 6px;
	margin-bottom: 4px;
	font-weight: 500;
	color: #3b4863;
	font-size: 11px;
	line-height: 1.35;
}

.consulta-ces-process-ref:last-child {
	margin-bottom: 0;
}

.consulta-ces-process-ref--link {
	cursor: pointer;
	color: #0866c6 !important;
	text-decoration: underline;
	text-underline-offset: 2px;
}

.consulta-ces-process-ref--link:hover {
	color: #064f98 !important;
}

.consulta-ces-process-ref--link:focus {
	outline: none;
	box-shadow: 0 0 0 2px rgba(8, 102, 198, 0.35);
	border-radius: 2px;
}

/* Painel do processo acima do VModal (backdrop z-index 99999), p.ex. Consulta CEs aberta */
.desk-page .process-form-content {
	z-index: 100050 !important;
}

/* Com Consulta CEs aberta: formulário do processo em tela cheia (cobre header + modal) */
.desk-page .process-form-content.process-form--fullscreen-over-modal {
	top: 0 !important;
	left: 0 !important;
	width: 100vw !important;
	height: 100vh !important;
	max-height: 100vh !important;
}

.desk-page .process-form-content.process-form--fullscreen-over-modal.showHeader {
	bottom: auto !important;
	height: 100vh !important;
	max-height: 100vh !important;
}

.consulta-ces-process-action-row {
	min-height: 34px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 6px;
}

.consulta-ces-process-action-row:last-child {
	margin-bottom: 0;
}

/* Padrão mesa: btn btn-icon rounded-circle (ver perfil / documentos) — compacto */
.consulta-ces-btn-sync-ce {
	width: 32px !important;
	min-width: 32px !important;
	height: 32px !important;
	padding: 0 !important;
}

.consulta-ces-btn-sync-ce > div {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
}

/* Mesmo padrão de borda das tabelas CRM (ex.: listagem em contact-form): reta, sem raio */
.consulta-ces-table-responsive {
	border-radius: 0;
	border: 1px solid #e2e2e2;
	box-shadow: none;
}

.consulta-ces-table-scroll {
	max-height: min(52vh, 520px);
	overflow: auto;
}

/* Mais altura útil para a grade no passo resultados */
.consulta-ces-vmodal--result .consulta-ces-table-scroll {
	max-height: min(68vh, 720px);
}

.consulta-ces-empty {
	background: #f8fafc;
	border-radius: 0;
	border: 1px dashed #e2e2e2;
}

</style>
